// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:44.874Z
// Property: 2626 Park (ID: 6737460151191753)
// Collections: 47 amenities, 12 floorplans (live), 28 photos, 70 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191753",
  "property_external_id": "4973408",
  "property_zillow_url": "https://www.zillow.com/apartments/tallahassee-fl/2626-park/5Xhyxf/",
  "property_apartments_url": "https://www.apartments.com/2626-park-tallahassee-fl/j7sqpe7/",
  "property_google_business_url": "https://www.google.com/maps/place/2626+Park/data=!4m2!3m1!1s0x0:0xc6d73d7be74a68e1?sa=X&ved=2ahUKEwjo6OaDwrySAxVitokEHbZKGHYQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321248693",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "2626-park",
  "property_name": "2626 Park",
  "property_website_url": "https://www.live2626park.com/",
  "property_domain": "https://www.live2626park.com/",
  "property_address": "2626 E Park Ave",
  "property_full_address": "2626 E Park Ave, Tallahassee, FL 32301",
  "property_address_1": "2626 E Park Ave",
  "property_address_2": null,
  "property_address_city": "Tallahassee",
  "property_address_state": "FL",
  "property_address_zip_full": "32301-0802",
  "property_address_zip": "32301",
  "property_address_country": "US",
  "property_address_county": "Leon County",
  "property_neighborhood_address": "Governors Square",
  "property_address_latitude": "30.4464512",
  "property_address_longitude": "-84.2370771",
  "property_email": "2626park@rrliving.com",
  "property_phone": "(850) 309-7667",
  "property_call_tracking_phone": "850-660-9358",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to 2626 Park in Tallahassee, FL! Discover our spacious one, two, and three-bedroom floor plans designed for comfort. Enjoy top-notch amenities like a pool, fitness center, and business center. With concierge service and controlled access, you're always supported here. Find your new home today—browse availability or schedule a tour!",
  "property_long_description": "Welcome to 2626 Park, the premier apartment community in the heart of Tallahassee, FL! With a range of thoughtfully designed floor plans—including one-bedroom, two-bedroom, and three-bedroom apartments—you're sure to find the perfect space to call home. Each residence combines modern convenience with comfortable living, tailored to suit your lifestyle.\n\nAt 2626 Park, exceptional amenities redefine your every day. Dive into relaxation at our stunning pool, stay active in our fully-equipped fitness center, or socialize with friends in our inviting clubhouse. Enjoy the convenience of on-site maintenance, controlled access, and a dedicated concierge to ensure all your needs are met. For added peace of mind, our property features gated access and key fob entry.\n\nEmbrace the outdoor lifestyle with our beautifully landscaped courtyard, picnic areas equipped with grills, and a serene roof terrace perfect for unwinding. Stay focused and productive in our well-equipped business center or take a break in the game room. With 24-hour access to online services and community-wide WiFi, staying connected has never been easier!\n\nYour furry friends are welcome, too, as we proudly offer pet care services. With convenient access to public transportation, exploring the vibrant city of Tallahassee is a breeze. \n\nWhy not take the next step toward modern living? Find your new home today at 2626 Park—browse our availability or schedule a tour to experience our exceptional community firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
    "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
    "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "440",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.04545454545455",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$199\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "65",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed (no breed restrictions). Up to 2 pets per unit (maximum of 3 pets total, with no more than 2 dogs).",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://dlpmeadowbrook.loftliving.com/login",
  "property_apply_now_url": "https://8873220.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-6854-72c1-87c8-3378c2a54fa2.webp",
  "property_primary_logo_media": {
    "alt_text": "Logo for 2626 Park.",
    "public_id": "019e1e0f-6854-72c1-87c8-3378c2a54fa2",
    "storage_key": "property/6737460151191753/019e1e0f-6854-72c1-87c8-3378c2a54fa2.webp",
    "width": 1920,
    "height": 967
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-66d4-7741-bfb5-24d2f6df2cdb.webp",
  "property_secondary_logo_media": {
    "alt_text": "2626 Park logo",
    "public_id": "019e1e0f-66d4-7741-bfb5-24d2f6df2cdb",
    "storage_key": "property/6737460151191753/019e1e0f-66d4-7741-bfb5-24d2f6df2cdb.webp",
    "width": 1467,
    "height": 738
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-66d4-7741-bfb5-24d2f6df2cdb.webp",
  "property_mono_white_logo_media": {
    "alt_text": "2626 Park logo",
    "public_id": "019e1e0f-66d4-7741-bfb5-24d2f6df2cdb",
    "storage_key": "property/6737460151191753/019e1e0f-66d4-7741-bfb5-24d2f6df2cdb.webp",
    "width": 1467,
    "height": 738
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-6854-72c1-87c8-3378c2a54fa2.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Logo for 2626 Park.",
    "public_id": "019e1e0f-6854-72c1-87c8-3378c2a54fa2",
    "storage_key": "property/6737460151191753/019e1e0f-6854-72c1-87c8-3378c2a54fa2.webp",
    "width": 1920,
    "height": 967
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "745 - 1196",
  "property_sqft_min": "745",
  "property_sqft_max": "1196",
  "property_price_range": "1065 - 1790",
  "property_price_min": "1065",
  "property_price_max": "1790",
  "property_available_units": 35,
  "property_facebook_url": "https://www.facebook.com/2626Park/",
  "property_instagram_url": "https://www.instagram.com/2626_park/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ5WcBpqZf7IgR4WhK53s918Y",
  "property_youtube_url": "https://www.youtube.com/channel/UCHfLFa0A_B3FfLzbtJCG_-w",
  "property_yelp_url": "https://www.yelp.com/biz/polos-on-park-internacional-realty-tallahassee",
  "property_tiktok_url": "https://www.tiktok.com/@2626.park",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 2626 Park",
  "property_home_romance_title": "Embrace the Comfort of Your New Community Together",
  "property_home_amenities_blurb": "<p>2626 Park offers spacious apartment rentals in Tallahassee, FL. Our one, two, and three-bedroom <a href=\"/floor-plans/\">floor plans</a> include walk-in closets, washer/dryer connections, and a private patio or balcony. Select apartments feature vaulted ceilings, granite countertops, hardwood flooring, and smart outlets with USB. Our apartment homes, ranging from 745-1,196 sq. ft., may also include carpeted flooring, air conditioning, and high-speed internet. Whether you’re working from home, hosting friends, or just unwinding on your patio, 2626 Park is built around the way you actually live.</p>",
  "property_home_floorplans_blurb": "<p>2626 Park Apartments places residents in the heart of Tallahassee, with convenient access to everything the city has to offer. For shopping, Governor's Square Mall on Apalachee Parkway is just minutes away, offering a full range of retail options. Cross Creek Square provides everyday essentials as well.</p>\n<p>The dining scene is equally vibrant. Savour on E. Park Ave — just down the street — is one of Tallahassee's highest-rated fine dining destinations. The Edison offers upscale American cuisine in a beautifully restored building, while Brick House Restaurant & Bar delivers a lively, casual atmosphere near College Avenue.</p>\n<p>Outdoor enthusiasts will love the proximity to Tom Brown Park, featuring walking trails, tennis courts, disc golf, mountain biking, and a dog park. Governor's Park offers a quieter escape with scenic wooded trails and open green space.</p>\n<p>The Florida Capitol Complex is a short commute from 2626 Park, and other major employers in the area include Tallahassee Memorial HealthCare and Florida State University, making our community easily accessible for commuters.</p>",
  "property_home_gallery_blurb": "At 2626 Park in Tallahassee, FL, every detail is designed with your comfort in mind. Choose from spacious floor plans—one, two, or three bedrooms—and indulge in amenities like a sparkling pool, state-of-the-art fitness center, and serene pet play area. Picture yourself living here, enjoying modern luxury and vibrant community life!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding 2626 Park in Tallahassee, FL! Choose from spacious one, two, or three-bedroom floor plans that fit your lifestyle. Explore local favorites and nearby attractions to enhance your living experience. **See what's around our community and start your adventure today!**",
  "property_home_reviews_blurb": "Experience the charm of 2626 Park, where residents rave about our “wonderful” staff and pristine amenities. Centrally located in Tallahassee, this pet-friendly, gated community ensures you feel right at home. Join our happy residents who appreciate prompt maintenance and a vibrant lifestyle—read their glowing reviews today!",
  "property_neighborhood_blurb": "<p>2626 Park Apartments places residents in the heart of Tallahassee, with convenient access to everything the city has to offer. For shopping, Governor's Square Mall on Apalachee Parkway is just minutes away, offering a full range of retail options. Cross Creek Square provides everyday essentials as well.</p>\n<p>The dining scene is equally vibrant. Savour on E. Park Ave — just down the street — is one of Tallahassee's highest-rated fine dining destinations. The Edison offers upscale American cuisine in a beautifully restored building, while Brick House Restaurant & Bar delivers a lively, casual atmosphere near College Avenue.</p>\n<p>Outdoor enthusiasts will love the proximity to Tom Brown Park, featuring walking trails, tennis courts, disc golf, mountain biking, and a dog park. Governor's Park offers a quieter escape with scenic wooded trails and open green space.</p>\n<p>The Florida Capitol Complex is a short commute from 2626 Park, and other major employers in the area include Tallahassee Memorial HealthCare and Florida State University, making our community easily accessible for commuters.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At 2626 Park, the amenities are just as impressive as the apartment homes themselves. Take a dip in one of our two swimming pools, soak up the sun on the sundeck, or fire up the grill for an evening with friends. Stay active in our fully equipped fitness center, or unwind in the resident lounge with cybercafe — the perfect spot to work, relax, or connect with neighbors.</p>\n<p>Friendly competition awaits at our sports courts, featuring foosball, cornhole, and ping pong. Package lockers keep your deliveries safe and secure, while door-to-door trash pickup means one less errand on your to-do list.</p>\n<p>Pet owners are right at home here, too. Our pet-friendly walking trails and on-site pet spa make 2626 Park a community your four-legged family members will love just as much as you do.</p>\n<p>This is apartment living, elevated.</p>",
  "property_applynow_blurb": "Discover your perfect home at 2626 Park in Tallahassee, FL! Choose from our spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities like a pool, fitness center, and clubhouse. Experience the convenience of controlled access and on-site maintenance. Apply now and lease online today!",
  "property_contactus_blurb": "Discover your ideal home at 2626 Park in Tallahassee, FL! Our spacious floor plans include stunning one, two, and three-bedroom apartments designed for comfort and style. Ready to learn more? Have questions? Contact our leasing team today to explore your new living space and experience all we have to offer!",
  "property_faqs_blurb": "At 2626 Park in Tallahassee, FL, we offer thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Have questions? Browse our FAQs page to discover more about our vibrant community and get the answers you need for a seamless living experience!",
  "property_floorplans_blurb": "<p>2626 Park offers pet-friendly apartments in Tallahassee, FL. Our one, two, and three-bedroom floor plans range from 745–1,196 sq. ft. and include walk-in closets, a pantry, and a private patio or balcony with beautiful views.</p>\n<p>Select apartments feature vaulted ceilings, granite countertops, and washer/dryer connections, with optional detached garages available for added convenience. Additional touches like door-to-door trash pickup make everyday living effortless.</p>\n<p>When it's time to get outside, our pet-friendly walking trails are right at your door. From morning walks on the trail to evenings on your private patio, 2626 Park is where Tallahassee feels like home.</p>",
  "property_gallery_blurb": "<p>Every picture tells a story, and at 2626 Park, it's one you'll want to be part of. Browse our gallery and imagine yourself coming home to a spacious <a href=\"/floor-plans/\">one, two, or three-bedroom apartment</a> with vaulted ceilings, granite countertops, and a private patio or balcony overlooking the community.</p>\n<p>Picture your mornings starting in a kitchen with a full pantry, and your evenings winding down with a walk along our pet-friendly trails. See yourself lounging poolside at one of our two swimming pools, hosting a cookout at the grilling stations, or breaking a sweat in our fully equipped fitness center.</p>\n<p>Every photo is a glimpse into the lifestyle waiting for you at 2626 Park. From the thoughtfully designed interiors to the <a href=\"/amenities/\">resort-style community spaces</a>, what you see is exactly what you get. Come experience it for yourself — schedule a tour today.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at 2626 Park in Tallahassee, FL! Our diverse floor plans include one, two, and three-bedroom options, complemented by luxurious amenities like a pool, fitness center, and clubhouse. Explore our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your perfect home at 2626 Park in Tallahassee, FL! With spacious one, two, and three-bedroom floor plans, you’ll find the ideal space for you and your friends. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the benefits of living together!",
  "property_residentaccess_blurb": "Welcome to 2626 Park, your ideal Tallahassee apartment community! Explore our diverse floor plans, featuring one, two, and three-bedroom options to suit your lifestyle. Access your resident portal today to effortlessly pay rent, schedule maintenance, and enjoy exclusive resident benefits! Experience convenience and comfort at 2626 Park.",
  "property_reviews_blurb": "At 2626 Park, residents rave about the “wonderful” staff and “great amenities,” including pristine pools and a pet-friendly environment. Perfectly situated in Tallahassee, our community offers quick access to local attractions. Hear firsthand experiences and discover why our apartments are a beloved choice for your next home!",
  "property_created_at": "1752257089675",
  "property_scheduletour_blurb": "Discover your ideal home at 2626 Park in Tallahassee, FL, featuring spacious one, two, and three-bedroom floor plans. Schedule a tour today to experience our vibrant community and see what our residents love most about living here! Explore your future apartment and envision your new lifestyle.",
  "property_thankyou_blurb": "Thank you for your interest in 2626 Park, the premier apartment community in Tallahassee, FL! Explore our diverse floor plans, including one, two, and three-bedroom options. A member of our team will contact you shortly to assist with your apartment search. Your new home awaits!",
  "property_virtualtours_blurb": "<p>Welcome to 2626 Park — and welcome home. Our virtual tours give you an up-close look at our one, two, and three-bedroom <a href=\"/floor-plans/\">apartment homes</a>, ranging from 745–1,196 sq. ft., complete with spacious walk-in closets, in-unit washer/dryer connections, and private patios or balconies with views. Select homes feature vaulted ceilings and granite countertops.</p>\n<p>Beyond your front door, our community <a href=\"/amenities/\">amenities</a> are designed to impress — two swimming pools with a sundeck and grilling stations, a fitness center, a resident lounge with cybercafe, package lockers, and sports courts with foosball, cornhole, and ping pong. Pet lovers will appreciate our walking trails and pet spa. Optional detached garages are also available.</p>\n<p>Explore every corner of our community from wherever you are, then come see it in person. Schedule your tour today and discover why 2626 Park is Tallahassee's place to call home.</p>",
  "property_copyright": "2025 All Rights Reserved. 2626 Park",
  "property_seo_title_home": "2626 Park | Apartments in Tallahassee, FL",
  "property_seo_description_home": "Discover your perfect home at 2626 Park in Tallahassee, FL! Explore our diverse floor plans, featuring one, two, and three-bedroom apartments designed for comfort and style. Enjoy unparalleled amenities such as a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. With controlled access, on-site maintenance, and pet care services, 2626 Park prioritizes your convenience and peace of mind. Join our vibrant community and take advantage of the business center, gameroom, and roof terrace. Find your new home today and experience the lifestyle you've been dreaming of!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Tallahassee, FL",
  "property_seo_description_floorplans": "Discover your dream apartment at 2626 Park in Tallahassee, FL! Explore our diverse floor plans featuring one, two, and three-bedroom options designed for your lifestyle. Browse our available apartment homes today and find the perfect layout that suits your needs!",
  "property_seo_title_amenities": "Amenities | Tallahassee, FL Apartments for Rent",
  "property_seo_description_amenities": "Discover your perfect home at 2626 Park in Tallahassee, FL! Explore our spacious one, two, and three-bedroom floor plans alongside a wealth of luxurious amenities. Enjoy resort-style living with a sparkling pool, state-of-the-art fitness center, and inviting clubhouse. Benefit from concierge services, 24-hour access, and controlled access for your peace of mind. Unwind in the courtyard or roof terrace, and take advantage of our business center and community-wide Wi-Fi. Your ideal lifestyle awaits—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Tallahassee, FL",
  "property_seo_description_gallery": "Discover your ideal home at 2626 Park in Tallahassee, FL! Explore our stunning photo gallery showcasing our spacious one, two, and three-bedroom floor plans, alongside a suite of luxurious amenities including a refreshing pool, fitness center, and inviting clubhouse. Enjoy community features such as controlled access, 24-hour maintenance, and pet care services. Experience the perfect blend of comfort and convenience! Picture yourself living here and take the first step toward your new lifestyle today!",
  "property_seo_title_virtualtours": "Virtual Tours | 2626 Park Apartments",
  "property_seo_description_virtualtours": "Discover your new home at 2626 Park in beautiful Tallahassee, FL! Explore our diverse floor plans, including one-, two-, and three-bedroom apartments, and find the perfect space for your lifestyle. Take a virtual tour of our community and apartments for rent today—experience the comfort and style that awaits you!",
  "property_seo_title_interactivemap": "Interactive Map | 2626 Park Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at 2626 Park in Tallahassee, FL! Choose from spacious one, two, or three-bedroom floor plans, and enjoy luxurious amenities like a pool, fitness center, rooftop terrace, and concierge service. With features like controlled access, on-site maintenance, and a vibrant clubhouse, comfort and convenience are at your fingertips. Explore our interactive community map to find available apartments, view pricing, and start your new adventure today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tallahassee, FL",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding 2626 Park in Tallahassee, FL! Explore one, two, and three-bedroom floor plans while uncovering local favorites and essential points of interest nearby. See what's around our community and immerse yourself in the ideal blend of comfort and convenience. Your new lifestyle awaits!",
  "property_seo_title_contact": "Contact Us | 2626 Park",
  "property_seo_description_contact": "Discover your ideal living space at 2626 Park in Tallahassee, FL! Choose from our stylish one, two, and three-bedroom floor plans designed for comfort and convenience. Have questions? Contact our leasing team today and find your perfect home!",
  "property_seo_title_faqs": "FAQs | Apartments in Tallahassee, FL",
  "property_seo_description_faqs": "Discover life at 2626 Park in Tallahassee, FL! Explore our spacious one, two, and three-bedroom floor plans, complemented by luxurious amenities like a pool, fitness center, and on-site concierge. Enjoy community-wide Wi-Fi, a gameroom, and a tranquil courtyard for relaxation. Have questions? Browse our FAQs page for answers about our vibrant community and discover why 2626 Park is the perfect place to call home. ",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tallahassee, FL",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at 2626 Park in Tallahassee, FL! Explore our spacious one, two, and three-bedroom floor plans along with premium amenities like a resort-style pool, fitness center, and rooftop terrace. Enjoy unparalleled convenience with controlled access, on-site maintenance, and a welcoming concierge. Don't just take our word for it—see what our residents have to say about living in our community! Visit our Resident Reviews page now!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tallahassee, FL",
  "property_seo_description_applynow": "Discover your dream home at 2626 Park, Tallahassee's premier apartment community! With spacious floor plans featuring one, two, and three-bedroom options, you'll find the perfect fit for your lifestyle. Enjoy unparalleled amenities, including a refreshing pool, state-of-the-art fitness center, rooftop terrace, and a welcoming clubhouse. Benefit from 24-hour access, concierge services, and controlled entry for peace of mind. Apply now and lease your new home online today—where comfort meets convenience in an inviting community atmosphere!",
  "property_seo_title_residentaccess": "Resident Access | 2626 Park",
  "property_seo_description_residentaccess": "\"Welcome to the 2626 Park Resident Access Login in Tallahassee, FL! Conveniently manage your apartment life by accessing your resident portal to pay rent, schedule maintenance, and stay connected. Log in now for seamless living at 2626 Park!\"",
  "property_seo_title_referafriend": "Refer A Friend | 2626 Park",
  "property_seo_description_referafriend": "\"Discover the vibrant community at 2626 Park in Tallahassee, FL! Great friends make great neighbors—refer a friend today and enjoy exclusive perks. Experience elevated living with outstanding amenities and a welcoming atmosphere. Start your referral journey now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | 2626 Park",
  "property_seo_description_scheduletour": "\"Experience modern living at 2626 Park in Tallahassee, FL! Discover our vibrant apartment community and schedule a tour today to explore exceptional amenities and welcoming spaces. Don’t miss out on your dream apartment—schedule your tour now!\"",
  "property_seo_title_privacy": "Privacy Policy | 2626 Park",
  "property_seo_description_privacy": "Discover peace of mind at 2626 Park in Tallahassee, FL. Our comprehensive Privacy Policy outlines how we protect your information while you enjoy our vibrant apartment community. **View our privacy policy** to learn more about your privacy rights and our commitment to safeguarding your data.",
  "property_seo_title_accessibility": "Website Accessibility | 2626 Park",
  "property_seo_description_accessibility": "\"Discover a welcoming home at 2626 Park in Tallahassee, FL. Our Accessibility Statement reflects our commitment to digital inclusion for all residents. Explore our apartments and see how we prioritize accessible living. Join our community today!\"",
  "property_seo_title_sitemap": "Sitemap | 2626 Park",
  "property_seo_description_sitemap": "\"Explore 2626 Park in Tallahassee, FL, with our easy-to-navigate sitemap! Discover our stunning apartment layouts, community amenities, and local attractions. Click to view our sitemap and start your journey to your new home today!\"",
  "property_seo_title_thankyou": "Thank You | 2626 Park",
  "property_seo_description_thankyou": "\"Thank you for reaching out to 2626 Park in Tallahassee, FL! Your inquiry is important to us, and a member of our team will contact you shortly to assist with your apartment search. Explore our vibrant community and discover your perfect home!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Tallahassee, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293557621",
  "amenities": [
    {
      "id": "custom_c1f8c6a2-aab6-4868-a27a-ec64d3e81ecb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Two Shimmering Swimming Pools with Outdoor Lounge and Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99e38798-25e0-48a6-aacb-6429b5f4ff48",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Social Sundeck with Grilling Stations and Barbecue",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8cbdb020-7f77-4b93-8722-c9201e4e47e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Social Terrace with Picnic Area and Outdoor Chess",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a6cbecb-e545-4c5f-8aa4-1a7155e97b6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "2 Sports Courts with Foosball, Cornhole, and Ping Pong",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d66d8503-ed8d-4fb3-9c32-02fe5429c79c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Full‑circuit Fitness Center with Cardio Equipment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bffdc6f5-2e6b-4279-9412-05ff820268cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Pet Washing Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_533a697b-5b6f-4e0d-8fd7-f80d19406b70",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d082f28f-bf50-4b44-a215-1cb15f109d0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑friendly with Walking and Hiking Trails",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_faf20b88-554e-47c0-88d0-3f8a6c7436e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Cyber Lounge and Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1439f8be-88e9-4483-9c48-ebe1dd8c5b68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Services Center with Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4746645f-59b3-4936-8d70-a517fa577ab7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_01c9b855-ad2f-4292-b382-f748fe29f97e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Secured Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_35d4cf22-f27b-4dae-904b-4c1b74fdb7db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Door‑to‑Door Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5dacaef3-9633-422c-a19b-90ba910ed389",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Greenery and Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d170dd1f-9fcc-4c13-90fb-cfbf0d386a5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99cc1299-7591-4378-9660-ca3003efe34b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_420bf3cc-37ae-4722-a118-f95731638677",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Corporate Housing Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9ab278d-7868-417b-85b7-3a419eecec5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b6f40b17-a4e9-4091-86b1-9789e75bd24c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88c8b41f-6593-451d-9d64-cd3baf518155",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_44fba69c-bb8a-4331-aa5f-7e860b8b368f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_94bd29ab-b450-47e0-861e-c666069d5ddd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1259661d-f9b5-4819-9ef1-ba52201aba9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb088a7b-4281-42af-b8c2-1ff2ebb7ce9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6753ed80-42dd-450c-900e-d0ed769ee96a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently Located Near Public Transportation, Freeways, Parks, Shopping, and Restaurants",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_15ac88f0-bdbf-4934-954f-825e640a4fa4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "9‑Foot and 16‑Foot Ceilings with Vaulted Ceilings Available*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b610b546-3e9d-44d7-86c5-8564e2d50f4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floorplans with Extra‑Large Square Footage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_757b8500-1995-471c-956d-e08b1f32b5c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Shaker-Style Cabinet Fronts with Black Cabinet Pulls*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4305ceff-04fb-4dfa-8131-18f3cbd5e011",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Granite-like Countertops in Kitchen and Bathrooms*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf03799b-e9c0-457f-9bdf-f2c0b10c3f3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Tile Backsplash*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0dbb079f-280c-435f-9d7a-4d18e1556cd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Chef‑Ready Kitchen with Storage Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e1997d6-2b33-4534-9fe0-7039296ab123",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast and Wet Bar*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_78ce759f-3107-4cd5-b5c8-7a2e91d694dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Gooseneck Faucet*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6f7e5005-a08c-493e-8129-51084c287955",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Luxury Wood‑Designed and Carpeted Flooring*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_89e3aeed-e54f-4a4d-b099-74010b29809b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Homes with Modern LED Lighting*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd0652be-b697-49db-ad30-73898b19223d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea20f361-4bbc-468f-a765-57e583093a12",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Smart Outlets with USB Charging*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cad932c5-68a0-4c24-8463-06e3d3ca8b28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Soaking Tubs with Curved Showerrod",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3895113-c244-47cf-a7f5-65bd5dfc183e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑Sized Washer and Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b9abfdcc-976c-4842-bc92-96dc9468551a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "2” Faux Wood Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6046abe-0e1a-4822-995f-e4fab7a95773",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios and Balconies",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b2604c0-37c8-479d-a7f3-c9240bbd3ad4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Central Heating and Air",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea1729b5-bed9-4255-95f5-da98c32ea41b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "High‑Speed Internet Access Included and Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83e9a305-cb4a-41b8-ad6f-8cc8dc3e5ebf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Desirable Views Available*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_15b24f9a-0246-4de5-9db9-c1317cd4e808",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7608cda2-62eb-4947-bb74-fadc666003d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient, Modern Black Appliance Package with Built‑In Microwave in Kitchen*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2ec4712-77c3-4d47-84f6-4b781bb516e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans with Decorative Light Kits in Living Areas and Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_b3fe4713-1378-4c6a-9609-e3fb74c99c49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-1a46-724c-8612-93a10a2d7557.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas under pergolas.",
        "public_id": "01a067f1-1a46-724c-8612-93a10a2d7557",
        "storage_key": "property/6737460151191753/01a067f1-1a46-724c-8612-93a10a2d7557.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded pergolas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas under pergolas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4eb2e93-1e38-40a1-9b9a-b1c37200b547",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-1a58-71dc-b4ba-1f62a3e68c11.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and shaded seating areas.",
        "public_id": "01a067f1-1a58-71dc-b4ba-1f62a3e68c11",
        "storage_key": "property/6737460151191753/01a067f1-1a58-71dc-b4ba-1f62a3e68c11.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded pergolas for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and shaded seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc0eaae8-4b52-4eb3-b27c-c8b641ea771d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-1e84-733c-9c87-b3f9b37ae17b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in a multifamily apartment.",
        "public_id": "01a067f1-1e84-733c-9c87-b3f9b37ae17b",
        "storage_key": "property/6737460151191753/01a067f1-1e84-733c-9c87-b3f9b37ae17b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish living room with a comfortable sofa and a modern kitchen area. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area in a multifamily apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f48b171-4d1b-438c-90d9-388deb3c71e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-19f5-75ef-b74b-2e06fab79106.webp",
      "image_media": {
        "alt_text": "Modern open-concept living and dining area with a sleek kitchen.",
        "public_id": "01a067f1-19f5-75ef-b74b-2e06fab79106",
        "storage_key": "property/6737460151191753/01a067f1-19f5-75ef-b74b-2e06fab79106.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area featuring a modern kitchen, perfect for entertaining and comfortable everyday living.",
      "link": "",
      "alt_text": "Modern open-concept living and dining area with a sleek kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f0924dc-0050-4e47-8f22-8604caeea23f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-1e7f-7512-99b5-5c22993f3f3b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and speckled countertops.",
        "public_id": "01a067f1-1e7f-7512-99b5-5c22993f3f3b",
        "storage_key": "property/6737460151191753/01a067f1-1e7f-7512-99b5-5c22993f3f3b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed kitchen featuring sleek white cabinetry, modern black appliances including a refrigerator, stove, and microwave, and stylish speckled countertops. This space is designed for both functionality and aesthetic appeal.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and speckled countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c5d6a6d-7f33-476b-b542-8309871083a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-1e91-75b7-b80d-d0f4148ffcd6.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and free weights",
        "public_id": "01a067f1-1e91-75b7-b80d-d0f4148ffcd6",
        "storage_key": "property/6737460151191753/01a067f1-1e91-75b7-b80d-d0f4148ffcd6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Fully equipped fitness center featuring a variety of weight machines and free weights for residents to use.",
      "link": "",
      "alt_text": "Gym with weight machines and free weights",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f84fb65-c3a5-40fc-b8bd-526076091c43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-19e4-71ec-9184-8e0d57329793.webp",
      "image_media": {
        "alt_text": "Clubhouse with seating area, bar, and kitchen.",
        "public_id": "01a067f1-19e4-71ec-9184-8e0d57329793",
        "storage_key": "property/6737460151191753/01a067f1-19e4-71ec-9184-8e0d57329793.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy our spacious clubhouse, featuring a comfortable seating area, a modern bar, and a convenient kitchen.",
      "link": "",
      "alt_text": "Clubhouse with seating area, bar, and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c774e16-eff6-4fc2-b9c6-472c33060e1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-1ef2-71c9-bbba-d04341e5b45e.webp",
      "image_media": {
        "alt_text": "Co-working space with computer, printer, and seating areas.",
        "public_id": "01a067f1-1ef2-71c9-bbba-d04341e5b45e",
        "storage_key": "property/6737460151191753/01a067f1-1ef2-71c9-bbba-d04341e5b45e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Work and relax in our comfortable co-working space, equipped with a computer, printer, and plush seating.",
      "link": "",
      "alt_text": "Co-working space with computer, printer, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4dd7844a-4124-4b9c-88e8-f1b5b3c33826",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-1a9f-7676-a237-cd7e485c543f.webp",
      "image_media": {
        "alt_text": "Spacious leasing office with desks, chairs, and artwork.",
        "public_id": "01a067f1-1a9f-7676-a237-cd7e485c543f",
        "storage_key": "property/6737460151191753/01a067f1-1a9f-7676-a237-cd7e485c543f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Welcome to our beautifully appointed leasing office, featuring comfortable seating and a modern design to assist you with all your needs.",
      "link": "",
      "alt_text": "Spacious leasing office with desks, chairs, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ee8b685b-9eb5-4782-b19a-1a791188f20a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/01a067f1-19f3-76df-8b73-81ef2bb36091.webp",
      "image_media": {
        "alt_text": "Secure package lockers with a digital interface and door access.",
        "public_id": "01a067f1-19f3-76df-8b73-81ef2bb36091",
        "storage_key": "property/6737460151191753/01a067f1-19f3-76df-8b73-81ef2bb36091.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Convenient and secure package lockers are available for all residents. Access your deliveries easily through our digital system.",
      "link": "",
      "alt_text": "Secure package lockers with a digital interface and door access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6334694a-bf5f-4812-a2d5-b9dd25013194",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-4c09-72b2-bf9a-45443ef7edbd.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment",
        "public_id": "019e60b0-4c09-72b2-bf9a-45443ef7edbd",
        "storage_key": "property/6737460151191753/019e60b0-4c09-72b2-bf9a-45443ef7edbd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and modern kitchen with white cabinetry and black appliances.",
      "link": "",
      "alt_text": "Living room and kitchen area in an apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f19f56b-d6c1-4caf-843f-359f22a00858",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-433d-7216-a1e9-802c0bb6d003.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
        "public_id": "019e60b0-433d-7216-a1e9-802c0bb6d003",
        "storage_key": "property/6737460151191753/019e60b0-433d-7216-a1e9-802c0bb6d003.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring sleek black appliances, ample cabinet space, and elegant granite countertops. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_50d9e7d5-f896-44a5-b0f4-4479bbed4cc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-42f7-75b8-a78e-c63f0ecb44a9.webp",
      "image_media": {
        "alt_text": "Living room and bedroom of an apartment",
        "public_id": "019e60b0-42f7-75b8-a78e-c63f0ecb44a9",
        "storage_key": "property/6737460151191753/019e60b0-42f7-75b8-a78e-c63f0ecb44a9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room with a sofa and accent chair, flowing into a bedroom with a bed and nightstand.",
      "link": "",
      "alt_text": "Living room and bedroom of an apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66bf88d3-4e50-4a9d-b2d1-f337c76e689c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-35b7-72d1-b0a4-d318089d206c.webp",
      "image_media": {
        "alt_text": "Bedroom with a king size bed, nightstands, and a ceiling fan.",
        "public_id": "019e60b0-35b7-72d1-b0a4-d318089d206c",
        "storage_key": "property/6737460151191753/019e60b0-35b7-72d1-b0a4-d318089d206c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with decorative pillows, complemented by matching nightstands and a ceiling fan for enhanced comfort.",
      "link": "",
      "alt_text": "Bedroom with a king size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7eb91e0b-c79c-46da-8dc7-42401aa4e98d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-16d6-72af-b629-e5de83dc61db.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, nightstands, and a ceiling fan.",
        "public_id": "019e60b0-16d6-72af-b629-e5de83dc61db",
        "storage_key": "property/6737460151191753/019e60b0-16d6-72af-b629-e5de83dc61db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, elegant nightstands with lamps, and a cooling ceiling fan.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf56eb78-081f-4049-8d3f-3176e5c569d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-07f4-777b-ae97-4a1ec0bc122f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with bathtub, toilet, and vanity with sink.",
        "public_id": "019e60b0-07f4-777b-ae97-4a1ec0bc122f",
        "storage_key": "property/6737460151191753/019e60b0-07f4-777b-ae97-4a1ec0bc122f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a white bathtub, toilet, and a spacious vanity with a sink. Relax and refresh in this stylish space.",
      "link": "",
      "alt_text": "Modern bathroom with bathtub, toilet, and vanity with sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_26870cbc-a979-434e-a011-6dc4eb05496c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-134e-74ff-abda-532ef4c5959a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019e60b0-134e-74ff-abda-532ef4c5959a",
        "storage_key": "property/6737460151191753/019e60b0-134e-74ff-abda-532ef4c5959a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a spacious vanity with ample counter space, a modern toilet, and a clean bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_22efa388-5869-4974-9b53-e190e798ce73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60ae-dedd-706a-9d62-66ced48ddab7.webp",
      "image_media": {
        "alt_text": "Pet grooming station with stainless steel tub, shower head, and paw print decor.",
        "public_id": "019e60ae-dedd-706a-9d62-66ced48ddab7",
        "storage_key": "property/6737460151191753/019e60ae-dedd-706a-9d62-66ced48ddab7.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Convenient pet grooming station featuring a large stainless steel tub, built-in shower, and playful paw print accents. A perfect amenity for pet-loving residents.",
      "link": "",
      "alt_text": "Pet grooming station with stainless steel tub, shower head, and paw print decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6c2503f-7bdc-4b11-8a97-f8343aa13032",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-184f-740e-9eeb-0e5864397e99.webp",
      "image_media": {
        "alt_text": "Large swimming pool with lounge chairs and a building in the background.",
        "public_id": "019e60b0-184f-740e-9eeb-0e5864397e99",
        "storage_key": "property/6737460151191753/019e60b0-184f-740e-9eeb-0e5864397e99.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Large swimming pool with lounge chairs and a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_672b65c3-395c-471e-99b3-13f9fe094a5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-11e1-739c-9311-54fd9dbb6379.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and pergolas.",
        "public_id": "019e60b0-11e1-739c-9311-54fd9dbb6379",
        "storage_key": "property/6737460151191753/019e60b0-11e1-739c-9311-54fd9dbb6379.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded pergolas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and pergolas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1492b57-5f7c-4f4f-9e94-60dca9633485",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60af-99c2-7366-b66e-d8d2ef47a115.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019e60af-99c2-7366-b66e-d8d2ef47a115",
        "storage_key": "property/6737460151191753/019e60af-99c2-7366-b66e-d8d2ef47a115.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10a5cb25-7808-451d-a67a-3af60756d501",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60b0-192b-72ed-901b-5ff92c2c13eb.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with lounge chairs and tables under a pergola.",
        "public_id": "019e60b0-192b-72ed-901b-5ff92c2c13eb",
        "storage_key": "property/6737460151191753/019e60b0-192b-72ed-901b-5ff92c2c13eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious outdoor lounge area, complete with comfortable seating and shaded pergolas.",
      "link": "",
      "alt_text": "Outdoor lounge area with lounge chairs and tables under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba2899e5-9c87-4912-997b-8eaa314a5eba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60af-db51-7343-94bd-624101642e21.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and lounge area surrounded by greenery and apartment buildings.",
        "public_id": "019e60af-db51-7343-94bd-624101642e21",
        "storage_key": "property/6737460151191753/019e60af-db51-7343-94bd-624101642e21.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling resort-style pool, complete with comfortable loungers and shaded seating areas, set amidst lush landscaping.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and lounge area surrounded by greenery and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e341f9e-f38b-4f1d-9745-e39976fc06d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60af-baff-712a-a200-64fa03a1948a.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and clubhouse at a multifamily property.",
        "public_id": "019e60af-baff-712a-a200-64fa03a1948a",
        "storage_key": "property/6737460151191753/019e60af-baff-712a-a200-64fa03a1948a.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax by the clubhouse. This community offers a resort-style living experience.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and clubhouse at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11128907-c65e-4904-b8c1-956e6f8da191",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60af-616d-7355-b0d9-c0ca5775a9d6.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with parking lots and surrounding trees.",
        "public_id": "019e60af-616d-7355-b0d9-c0ca5775a9d6",
        "storage_key": "property/6737460151191753/019e60af-616d-7355-b0d9-c0ca5775a9d6.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "An aerial view showcases the apartment buildings, ample parking, and lush green surroundings.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with parking lots and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_861b706b-67c5-4b3a-96db-0ca5f9c8aa42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60af-649d-72a4-850c-4e4c8945b5e8.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property surrounded by trees, featuring apartment buildings and a swimming pool.",
        "public_id": "019e60af-649d-72a4-850c-4e4c8945b5e8",
        "storage_key": "property/6737460151191753/019e60af-649d-72a4-850c-4e4c8945b5e8.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Discover serene living in this apartment community, nestled amidst lush greenery. Enjoy amenities like the outdoor swimming pool and well-maintained grounds.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property surrounded by trees, featuring apartment buildings and a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c53def46-a3fb-49b0-96b1-55e3cdb9f2d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60af-536b-72da-bc33-46498852e391.webp",
      "image_media": {
        "alt_text": "Outdoor recreational area with cornhole boards, picnic tables, and shaded seating.",
        "public_id": "019e60af-536b-72da-bc33-46498852e391",
        "storage_key": "property/6737460151191753/019e60af-536b-72da-bc33-46498852e391.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy outdoor fun and relaxation in this community amenity featuring cornhole boards, shaded seating areas, and picnic tables.",
      "link": "",
      "alt_text": "Outdoor recreational area with cornhole boards, picnic tables, and shaded seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb80df2a-88dc-490f-93d4-2e767f030b49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e60af-3036-7414-9ecc-73e8217049c3.webp",
      "image_media": {
        "alt_text": "Aerial view of the property's main building and surrounding grounds.",
        "public_id": "019e60af-3036-7414-9ecc-73e8217049c3",
        "storage_key": "property/6737460151191753/019e60af-3036-7414-9ecc-73e8217049c3.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "An aerial view showcases the property's central building, complete with a distinctive tower, and the meticulously landscaped grounds, including parking areas and lush greenery.",
      "link": "",
      "alt_text": "Aerial view of the property's main building and surrounding grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_883517eb-4320-471f-b80e-ec3dd4e9af15",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Savour",
      "poi_type": "Restaurants",
      "poi_address": "115 E Park Ave, Tallahassee, FL 32301, USA",
      "poi_short_description": "Upscale steak, seafood & cocktails turned out in an elegant restaurant with chandeliers & a bar.",
      "poi_long_description": "Upscale steak, seafood & cocktails turned out in an elegant restaurant with chandeliers & a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-5dc2-7118-b26e-b90cd07dbc5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-5dc2-7118-b26e-b90cd07dbc5e",
        "storage_key": "property/6737460151191753/019e1e12-5dc2-7118-b26e-b90cd07dbc5e.webp",
        "width": 1280,
        "height": 930
      },
      "poi_business_url": "https://www.savourtallahassee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4139133467018214839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savour",
      "poi_latitude": "30.4416768",
      "poi_longitude": "-84.2812703",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-765-6966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr0qYl3D17IgRtz2NS_UncTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cf8e3257-e21d-42eb-9df5-98743bb5b635",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Bar 1903",
      "poi_type": "Restaurants",
      "poi_address": "209 E Park Ave, Tallahassee, FL 32301, USA",
      "poi_short_description": "Old-timey bar at the Walker Library, serving cocktails and small plates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-5521-7702-b54e-f9e1d75456bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-5521-7702-b54e-f9e1d75456bc",
        "storage_key": "property/6737460151191753/019e1e12-5521-7702-b54e-f9e1d75456bc.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://bar1903tlh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13328931149357162780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bar-1903",
      "poi_latitude": "30.4417004",
      "poi_longitude": "-84.28014739999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 850-354-9739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-aa1e-709a-bd91-7033df06c886.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e12-aa1e-709a-bd91-7033df06c886",
        "storage_key": "property/6737460151191753/019e1e12-aa1e-709a-bd91-7033df06c886.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY3i4u6r17IgRHKESuULg-bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "custom_b6b60ca4-7ae4-4025-8685-ea410cc91be5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Il Lusso",
      "poi_type": "Restaurants",
      "poi_address": "201 E Park Ave #100, Tallahassee, FL 32301, USA",
      "poi_short_description": "Airy, upscale restaurant furnishing Italian-style meat & seafood mains, plus pasta & small plates.",
      "poi_long_description": "Airy, upscale restaurant furnishing Italian-style meat & seafood mains, plus pasta & small plates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-5384-7155-8941-3559d487e90c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-5384-7155-8941-3559d487e90c",
        "storage_key": "property/6737460151191753/019e1e12-5384-7155-8941-3559d487e90c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://illussotally.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9191232966242690926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "il-lusso",
      "poi_latitude": "30.4415686",
      "poi_longitude": "-84.2804728",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-765-8620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qadHr17IgRbmfBgK_RjX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_87450a87-5da4-46eb-85c5-f4e7bd822933",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Brick House Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "402 W College Ave, Tallahassee, FL 32301, USA",
      "poi_short_description": "Classic Tallahassee brick house converted into a bustling American restaurant with patio seating.",
      "poi_long_description": "Classic Tallahassee brick house converted into a bustling American restaurant with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-606a-736c-8800-8e633f32390f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-606a-736c-8800-8e633f32390f",
        "storage_key": "property/6737460151191753/019e1e12-606a-736c-8800-8e633f32390f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://brickhousetally.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3371281936867972989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brick-house-restaurant--bar",
      "poi_latitude": "30.4409033",
      "poi_longitude": "-84.2859438",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-577-1230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiboF1nP17IgRfde0TA8zyS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c4f5e1a4-17c8-4b77-9c94-044cf765a977",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Kool Beanz Cafe",
      "poi_type": "Restaurants",
      "poi_address": "921 Thomasville Rd, Tallahassee, FL 32303, USA",
      "poi_short_description": "Popular lunch & dinner nook serving an eclectic American menu in a colorful, offbeat setting.",
      "poi_long_description": "Popular lunch & dinner nook serving an eclectic American menu in a colorful, offbeat setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-588f-77da-a4c0-8d767da304b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-588f-77da-a4c0-8d767da304b5",
        "storage_key": "property/6737460151191753/019e1e12-588f-77da-a4c0-8d767da304b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.koolbeanzcafe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1869525636836525950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kool-beanz-cafe",
      "poi_latitude": "30.4523528",
      "poi_longitude": "-84.2787269",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-224-2466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0eijEIP17IgRfocgWqnj8Rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_821561fa-45e6-4c94-b287-7f6ebc946476",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Izzy | Pub • Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "1123-3 Thomasville Rd, Tallahassee, FL 32303, USA",
      "poi_short_description": "Relaxed, wood-clad Japanese option for Asian pub fare, small plates & sushi plus craft beer & sake.",
      "poi_long_description": "Relaxed, wood-clad Japanese option for Asian pub fare, small plates & sushi plus craft beer & sake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-54a0-7358-b9ac-0c15bb027f5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-54a0-7358-b9ac-0c15bb027f5e",
        "storage_key": "property/6737460151191753/019e1e12-54a0-7358-b9ac-0c15bb027f5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8348894325051155662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "izzy--pub--sushi-bar",
      "poi_latitude": "30.4550938",
      "poi_longitude": "-84.2777129",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-222-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfe57e4T17IgRzuTyfyc73XM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_ce27ad09-c1c1-4c79-aa35-629cc25bee54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Food Glorious Food",
      "poi_type": "Restaurants",
      "poi_address": "1950 Thomasville Rd, Tallahassee, FL 32303, USA",
      "poi_short_description": "Seasonal American fare served in an airy space with stone walls, modern paintings & a patio.",
      "poi_long_description": "Seasonal American fare served in an airy space with stone walls, modern paintings & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-5137-70fd-8ebd-a02089e948ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-5137-70fd-8ebd-a02089e948ca",
        "storage_key": "property/6737460151191753/019e1e12-5137-70fd-8ebd-a02089e948ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://foodgloriousfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1774182667343387130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-glorious-food",
      "poi_latitude": "30.4672175",
      "poi_longitude": "-84.2689784",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 850-224-9974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZRi3WFf7IgR-lmoZbwpnxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_aab24be5-32fc-43d1-8ded-7f25580dbc1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "The Edison - Restaurant Tallahassee",
      "poi_type": "Restaurants",
      "poi_address": "470 Suwannee St, Tallahassee, FL 32301, USA",
      "poi_short_description": "Chic outpost in a former power station serving international fare, plus a deck & views of the park.",
      "poi_long_description": "Chic outpost in a former power station serving international fare, plus a deck & views of the park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-596f-72fb-9b23-c3afd56fd8f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-596f-72fb-9b23-c3afd56fd8f9",
        "storage_key": "property/6737460151191753/019e1e12-596f-72fb-9b23-c3afd56fd8f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.edisontally.com/?utm_source=Google%20My%20Business&utm_medium=Website%20Button&utm_campaign=Tallahassee",
      "poi_directions_map_url": "https://maps.google.com/?cid=7729992004093618202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-edison---restaurant-tallahassee",
      "poi_latitude": "30.433656",
      "poi_longitude": "-84.2773831",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 850-765-9771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL8BLqHz17IgRGiicwMVyRms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1d22d9da-b78a-4e6f-8a58-3be0f413525b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Bella Bella",
      "poi_type": "Restaurants",
      "poi_address": "123 E 5th Ave, Tallahassee, FL 32303, USA",
      "poi_short_description": "Italian fare, craft beers & cocktails served up in funky digs with outdoor seating.",
      "poi_long_description": "Italian fare, craft beers & cocktails served up in funky digs with outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-55e1-75b6-9894-49bb912deee4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-55e1-75b6-9894-49bb912deee4",
        "storage_key": "property/6737460151191753/019e1e12-55e1-75b6-9894-49bb912deee4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thebellabella.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16951089876342662239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bella-bella",
      "poi_latitude": "30.4546341",
      "poi_longitude": "-84.28098",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 850-412-1114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9dVgX5v17IgRX-Qfi25ePus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_f83438de-b395-4358-bb53-e382665866ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Black Dog Cafe",
      "poi_type": "Restaurants",
      "poi_address": "229 Lake Ella Dr, Tallahassee, FL 32303, USA",
      "poi_short_description": "Waterfront cafe with a patio, offering espresso drinks & light fare in a comfortable atmosphere.",
      "poi_long_description": "Waterfront cafe with a patio, offering espresso drinks & light fare in a comfortable atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-5168-74f7-a9df-bdef2d060c56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-5168-74f7-a9df-bdef2d060c56",
        "storage_key": "property/6737460151191753/019e1e12-5168-74f7-a9df-bdef2d060c56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/tallycoffee/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17992780666053523273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-dog-cafe",
      "poi_latitude": "30.4623195",
      "poi_longitude": "-84.2798296",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 850-224-2518",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-aa2b-70fb-b26c-b83f2a2e35de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e12-aa2b-70fb-b26c-b83f2a2e35de",
        "storage_key": "property/6737460151191753/019e1e12-aa2b-70fb-b26c-b83f2a2e35de.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJEwrBxI_17IgRSfeima8ys_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_eb46198e-e828-4de5-bc7d-c78093078bfd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Uptown Cafe and Catering",
      "poi_type": "Restaurants",
      "poi_address": "1325 Miccosukee Rd, Tallahassee, FL 32308, USA",
      "poi_short_description": "Comfy mainstay offering breakfast, lunch & all-day brunch, including sandwiches & salads.",
      "poi_long_description": "Comfy mainstay offering breakfast, lunch & all-day brunch, including sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-658c-7423-90cc-66d2b1767563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-658c-7423-90cc-66d2b1767563",
        "storage_key": "property/6737460151191753/019e1e12-658c-7423-90cc-66d2b1767563.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uptowncafeandcatering.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3958184986705310540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-cafe-and-catering",
      "poi_latitude": "30.455042",
      "poi_longitude": "-84.26258399999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 850-219-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-aa2b-70fb-b26c-b83f2a2e35de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e12-aa2b-70fb-b26c-b83f2a2e35de",
        "storage_key": "property/6737460151191753/019e1e12-aa2b-70fb-b26c-b83f2a2e35de.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ_8ifyHtf7IgRTLPaJ0ZM7jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_1fc9739b-7e48-42a0-bec0-092b6191b989",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "The Bada Bean",
      "poi_type": "Restaurants",
      "poi_address": "2500 Apalachee Pkwy B, Tallahassee, FL 32301, USA",
      "poi_short_description": "This casual coffee shop with health-conscious options serves classic morning eats & sandwiches.",
      "poi_long_description": "This casual coffee shop with health-conscious options serves classic morning eats & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-6391-76ed-b5ae-8427a69aee14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-6391-76ed-b5ae-8427a69aee14",
        "storage_key": "property/6737460151191753/019e1e12-6391-76ed-b5ae-8427a69aee14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thebadabean.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10865322318377536074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bada-bean",
      "poi_latitude": "30.4291206",
      "poi_longitude": "-84.2395488",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 850-562-2326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR1VX7Llf7IgRSkoE5RRhyZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_43a1ab9a-7bf3-4205-b15d-298ffb213caf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Poco Vino Wine Bar & Market",
      "poi_type": "Restaurants",
      "poi_address": "225 S Adams St, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-62cc-761b-b545-a0c030117206.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-62cc-761b-b545-a0c030117206",
        "storage_key": "property/6737460151191753/019e1e12-62cc-761b-b545-a0c030117206.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.pocovinowine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=886747016162591137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poco-vino-wine-bar--market",
      "poi_latitude": "30.439876",
      "poi_longitude": "-84.2817766",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 850-320-4552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-aa1e-709a-bd91-7033df06c886.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e12-aa1e-709a-bd91-7033df06c886",
        "storage_key": "property/6737460151191753/019e1e12-aa1e-709a-bd91-7033df06c886.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHzMalLn17IgRoUECiLZbTgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_e8f4a9be-c574-4e15-a5c0-5e454a484211",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Charlie Park",
      "poi_type": "Restaurants",
      "poi_address": "801 S Gadsden St, Tallahassee, FL 32301, USA",
      "poi_short_description": "Upscale rooftop bar and eatery for small plates, dessert and cocktails (some with local flavors).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-6c27-734a-86dd-0e7c4103ff02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-6c27-734a-86dd-0e7c4103ff02",
        "storage_key": "property/6737460151191753/019e1e12-6c27-734a-86dd-0e7c4103ff02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://charlieparkrooftop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14022242661084156372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlie-park",
      "poi_latitude": "30.4348343",
      "poi_longitude": "-84.278072",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-759-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzafydb317IgR1NE_QGgDmcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_099156c6-0f59-4394-bdad-1742df914bd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "La Tiendita Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1840 N Monroe St, Tallahassee, FL 32303, USA",
      "poi_short_description": "Colorful, art-lined cafe with a lively vibe offering classic Mexican plates with beer & margaritas.",
      "poi_long_description": "Colorful, art-lined cafe with a lively vibe offering classic Mexican plates with beer & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-6978-7226-828e-3c0d2710aac4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-6978-7226-828e-3c0d2710aac4",
        "storage_key": "property/6737460151191753/019e1e12-6978-7226-828e-3c0d2710aac4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://latienditatally.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15403510448808992695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-tiendita-mexican-restaurant",
      "poi_latitude": "30.4652324",
      "poi_longitude": "-84.28386239999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 850-523-1494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0c-72ee-9c89-dab92adee963",
        "storage_key": "property/6737460151191753/019e1e0f-3f0c-72ee-9c89-dab92adee963.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQybVdZH17IgRtx9HUyRDxNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_421583a4-abc3-4fde-a728-e7896b074aef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Publix Super Market at Governors Crossing II",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 N Blair Stone Rd Ste 301, Tallahassee, FL 32301, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-6a1d-761f-a995-a475998fd135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-6a1d-761f-a995-a475998fd135",
        "storage_key": "property/6737460151191753/019e1e12-6a1d-761f-a995-a475998fd135.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1051&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=16483624772242179457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-governors-crossing-ii",
      "poi_latitude": "30.4424128",
      "poi_longitude": "-84.2477474",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 850-219-6211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0a-7709-a462-3c2c9bb7ae8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0a-7709-a462-3c2c9bb7ae8f",
        "storage_key": "property/6737460151191753/019e1e0f-3f0a-7709-a462-3c2c9bb7ae8f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0JA5aFf7IgRgQVTeGWZweQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_26e54968-a358-48c0-8d38-b188964fa4e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2425 Apalachee Pkwy, Tallahassee, FL 32301, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-6f3f-733e-b74d-bd5b5cff3229.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-6f3f-733e-b74d-bd5b5cff3229",
        "storage_key": "property/6737460151191753/019e1e12-6f3f-733e-b74d-bd5b5cff3229.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/fl/tallahassee/2425-apalachee-parkway/l782",
      "poi_directions_map_url": "https://maps.google.com/?cid=151856062180582476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "30.427574",
      "poi_longitude": "-84.23997",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0a-7709-a462-3c2c9bb7ae8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0a-7709-a462-3c2c9bb7ae8f",
        "storage_key": "property/6737460151191753/019e1e0f-3f0a-7709-a462-3c2c9bb7ae8f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWlwXxpf7IgRTGRDs0iAGwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_69a4a892-a9e9-497b-8295-91aa6fec95ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2120 Apalachee Pkwy, Tallahassee, FL 32301, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-71ab-738c-9843-094fcb989307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-71ab-738c-9843-094fcb989307",
        "storage_key": "property/6737460151191753/019e1e12-71ab-738c-9843-094fcb989307.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/tallahassee/844",
      "poi_directions_map_url": "https://maps.google.com/?cid=5687947945587806416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "30.4330543",
      "poi_longitude": "-84.24449899999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 850-671-2041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f47-75e7-bf39-b12f5de13400",
        "storage_key": "property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHZwDObxf7IgR0JCsPYWm704",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1775a53c-151b-4446-bd8c-73c334715a8e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3535 Apalachee Pkwy, Tallahassee, FL 32311, USA",
      "poi_short_description": "Department store carrying apparel, electronics, groceries, home furnishings, and other merchandise.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7197-733c-ade6-577e6787b3c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7197-733c-ade6-577e6787b3c7",
        "storage_key": "property/6737460151191753/019e1e12-7197-733c-ade6-577e6787b3c7.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1077-tallahassee-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8860138604477661058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.4258924",
      "poi_longitude": "-84.2144373",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 850-656-2732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f47-75e7-bf39-b12f5de13400",
        "storage_key": "property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ53C9sEZe7IgRgr-dJB6J9Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f50220e4-233a-4beb-a751-63f7d68ac00e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Governor’s Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1500 Apalachee Pkwy, Tallahassee, FL 32301, USA",
      "poi_short_description": "2-level mall with familiar chain retailers & department stores & a food court with global eats.",
      "poi_long_description": "2-level mall with familiar chain retailers & department stores & a food court with global eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-0713-7147-ab15-4bf8d6373d4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0f-0713-7147-ab15-4bf8d6373d4d",
        "storage_key": "property/6737460151191753/019e1e0f-0713-7147-ab15-4bf8d6373d4d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.governorssquare.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14813667174901766619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "governors-square",
      "poi_latitude": "30.4365855",
      "poi_longitude": "-84.2537009",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 850-877-8107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f47-75e7-bf39-b12f5de13400",
        "storage_key": "property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6X2Ibppf7IgR21niNM-3lM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1d93c870-5d17-4316-a0eb-99844d1cbe27",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1400 Apalachee Pkwy, Tallahassee, FL 32301, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7150-74ef-b841-463125941ed3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7150-74ef-b841-463125941ed3",
        "storage_key": "property/6737460151191753/019e1e12-7150-74ef-b841-463125941ed3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/fl/tallahassee/1400-apalachee-pkwy-435.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=12640056202822989462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "30.437463",
      "poi_longitude": "-84.25921799999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 850-942-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f47-75e7-bf39-b12f5de13400",
        "storage_key": "property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHTVBVJZf7IgRlrY8hiWAaq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_a397cb15-1cf4-4702-8801-aa74daeb2f5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "DICK'S Sporting Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1729 Apalachee Pkwy, Tallahassee, FL 32301, USA",
      "poi_short_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_long_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7269-7438-80c6-79a4e25e0a6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7269-7438-80c6-79a4e25e0a6f",
        "storage_key": "property/6737460151191753/019e1e12-7269-7438-80c6-79a4e25e0a6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.dickssportinggoods.com/fl/tallahassee/1099/?seo=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=10115606049215260673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dicks-sporting-goods",
      "poi_latitude": "30.4311518",
      "poi_longitude": "-84.25128939999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 850-309-0490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f47-75e7-bf39-b12f5de13400",
        "storage_key": "property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9yXUcZZf7IgRAahEYxvaYYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_42870e49-8488-4b13-a273-9b7e252aa544",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "1233 Apalachee Pkwy, Tallahassee, FL 32301, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-714d-7589-ad3a-29cc97189b53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-714d-7589-ad3a-29cc97189b53",
        "storage_key": "property/6737460151191753/019e1e12-714d-7589-ad3a-29cc97189b53.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15606751080916411484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "30.4362609",
      "poi_longitude": "-84.2630259",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 850-656-2325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f47-75e7-bf39-b12f5de13400",
        "storage_key": "property/6737460151191753/019e1e0f-3f47-75e7-bf39-b12f5de13400.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUblWiIVf7IgRXGT3g2tRltg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_1a4445af-8e07-4a8c-b675-181a26d0b166",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "2956 E Park Ave, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7533-7760-aabc-579a11cfcfc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7533-7760-aabc-579a11cfcfc5",
        "storage_key": "property/6737460151191753/019e1e12-7533-7760-aabc-579a11cfcfc5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/tallahassee/2956-e-park-ave/2705989?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5865467067357318869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "30.4422508",
      "poi_longitude": "-84.22735139999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 850-656-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-aa50-7765-9e36-2a97339b5f90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e12-aa50-7765-9e36-2a97339b5f90",
        "storage_key": "property/6737460151191753/019e1e12-aa50-7765-9e36-2a97339b5f90.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ443Hx1Re7IgR1c6VnzhTZlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_d5d02add-2472-4854-986c-234e596ffdf3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Childcare Network",
      "poi_type": "Education",
      "poi_address": "2881 E Park Ave, Tallahassee, FL 32301, USA",
      "poi_short_description": "Clean, secure day care center with friendly staff who offer social and emotional learning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-74b3-743e-bf04-999cc3553d96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-74b3-743e-bf04-999cc3553d96",
        "storage_key": "property/6737460151191753/019e1e12-74b3-743e-bf04-999cc3553d96.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://schools.childcarenetwork.com/fl/tallahassee/2881-east-park-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=2490230128949324010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childcare-network",
      "poi_latitude": "30.440825",
      "poi_longitude": "-84.2295853",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 850-877-7729",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEa7DZatf7IgR6uj_xBsTjyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_9dc953f4-eec0-4b9e-b630-e53b598d8f90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "A Great Beginning Daycare Center",
      "poi_type": "Education",
      "poi_address": "926 E Park Ave, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7720-700f-99dd-d3e19749d930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7720-700f-99dd-d3e19749d930",
        "storage_key": "property/6737460151191753/019e1e12-7720-700f-99dd-d3e19749d930.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/people/A-Great-Beginning-Daycare-Center/100087652561767/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10537491160048410429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-great-beginning-daycare-center",
      "poi_latitude": "30.4419335",
      "poi_longitude": "-84.2659351",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 850-577-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJATI4uxBf7IgRPR-BSmGwPJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_71c2e8b4-3ac2-43d6-963b-4918c2ccc680",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Elizabeth Cobb Middle School",
      "poi_type": "Education",
      "poi_address": "915 Hillcrest St, Tallahassee, FL 32308, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.leonschools.net/cobb",
      "poi_directions_map_url": "https://maps.google.com/?cid=162744311164353759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elizabeth-cobb-middle-school",
      "poi_latitude": "30.4513435",
      "poi_longitude": "-84.26813039999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-488-3364",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz9X0635f7IgR37wquBYvQgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_52375e9f-572f-4362-979e-a74f467114d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Leon High School",
      "poi_type": "Education",
      "poi_address": "550 E Tennessee St, Tallahassee, FL 32308, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-776d-74f3-aaf0-ee2e0b414e5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-776d-74f3-aaf0-ee2e0b414e5b",
        "storage_key": "property/6737460151191753/019e1e12-776d-74f3-aaf0-ee2e0b414e5b.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.leonschools.net/leon",
      "poi_directions_map_url": "https://maps.google.com/?cid=140157206965093448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leon-high-school",
      "poi_latitude": "30.4455394",
      "poi_longitude": "-84.2754211",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-617-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS8vwCHD17IgRSITdtTzw8QE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5a58018f-c089-4278-968d-deb306a09814",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Rickards High School",
      "poi_type": "Education",
      "poi_address": "3013 Jim Lee Rd, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7a93-7553-b31c-4bd10ba59fce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7a93-7553-b31c-4bd10ba59fce",
        "storage_key": "property/6737460151191753/019e1e12-7a93-7553-b31c-4bd10ba59fce.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.leonschools.net/rickards",
      "poi_directions_map_url": "https://maps.google.com/?cid=16672017733336019723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rickards-high-school",
      "poi_latitude": "30.407645",
      "poi_longitude": "-84.2634386",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-414-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ15R_f_tf7IgRC7OB3MvnXuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1f7dab2d-f95b-419e-8b64-96dcf08fe399",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida A&M University Developmental Research School",
      "poi_type": "Education",
      "poi_address": "400 W Orange Ave, Tallahassee, FL 32307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-776c-74a9-adc4-4514c31318c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-776c-74a9-adc4-4514c31318c4",
        "storage_key": "property/6737460151191753/019e1e12-776c-74a9-adc4-4514c31318c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.famudrs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2174602286944006367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-am-university-developmental-research-school",
      "poi_latitude": "30.4139981",
      "poi_longitude": "-84.2890388",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 850-412-5930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbaByO0_17IgR37AMKUK9LR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e79108c6-622d-4cc7-9368-22502f36029d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida State University Office of Admissions",
      "poi_type": "Education",
      "poi_address": "A2500 University Center, 282 Champions Way, Tallahassee, FL 32306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-783a-77ec-ac48-2ccf2296afb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-783a-77ec-ac48-2ccf2296afb5",
        "storage_key": "property/6737460151191753/019e1e12-783a-77ec-ac48-2ccf2296afb5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://admissions.fsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8132228583458141417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-state-university-office-of-admissions",
      "poi_latitude": "30.4386139",
      "poi_longitude": "-84.3030559",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 850-644-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu2OniAj17IgR6fRMbc9623A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "custom_475efd05-0775-40cb-a6e5-1be064c743ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Maclay School",
      "poi_type": "Education",
      "poi_address": "3737 N Meridian Rd, Tallahassee, FL 32312, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7a46-743c-8177-3742a7668749.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7a46-743c-8177-3742a7668749",
        "storage_key": "property/6737460151191753/019e1e12-7a46-743c-8177-3742a7668749.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.maclay.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1388375903544477365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maclay-school",
      "poi_latitude": "30.5225211",
      "poi_longitude": "-84.2733933",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 850-893-2138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgRGYkSb27IgRtQZ7QYeARBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_da50f67f-9dfb-458c-80a4-2643d9aac89d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida State University School District",
      "poi_type": "Education",
      "poi_address": "3000 School House Rd, Tallahassee, FL 32311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7bcf-75f4-87ab-10cfa3da77bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7bcf-75f4-87ab-10cfa3da77bc",
        "storage_key": "property/6737460151191753/019e1e12-7bcf-75f4-87ab-10cfa3da77bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fsus.school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15105272215131628830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-state-university-school-district",
      "poi_latitude": "30.384023",
      "poi_longitude": "-84.22253599999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 850-245-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9c7Cso5g7IgRHqV_agy1oNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ea0020e6-fba9-40bc-aad8-41cc3fa059a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "LeMoyne Arts",
      "poi_type": "Entertainment",
      "poi_address": "125 N Gadsden St, Tallahassee, FL 32301, USA",
      "poi_short_description": "Showcasing local artists, this gallery set in an 1854 house also has a gift shop and outdoor gardens.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7dbe-7386-8841-4c1163235560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7dbe-7386-8841-4c1163235560",
        "storage_key": "property/6737460151191753/019e1e12-7dbe-7386-8841-4c1163235560.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lemoyne.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5285593406731870926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lemoyne-arts",
      "poi_latitude": "30.44319",
      "poi_longitude": "-84.2780183",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-222-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9Wof3n17IgRzmJm-zIzWkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_f4fd3829-9f68-4f66-961f-311848cbe164",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Adderley Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "1001 S Gadsden St, Tallahassee, FL 32301, USA",
      "poi_short_description": "Casual outdoor amphitheater hosting concerts and other live events in a park setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7e32-748b-aae5-a56f04e128f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7e32-748b-aae5-a56f04e128f1",
        "storage_key": "property/6737460151191753/019e1e12-7e32-748b-aae5-a56f04e128f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://theadderleyamphitheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15325236147871237303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adderley-amphitheater",
      "poi_latitude": "30.4342406",
      "poi_longitude": "-84.2768418",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-671-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeZd-qWX17IgRt0TXdBQtrtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_e938a56d-ce74-4444-9dda-469314877e26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "TALLAHASSEE FILM SOCIETY",
      "poi_type": "Entertainment",
      "poi_address": "918 1/2 Railroad Ave, Tallahassee, FL 32310, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-7dcb-71cb-8a2a-82777f416eea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-7dcb-71cb-8a2a-82777f416eea",
        "storage_key": "property/6737460151191753/019e1e12-7dcb-71cb-8a2a-82777f416eea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tallahasseefilms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7028475814261837483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tallahassee-film-society",
      "poi_latitude": "30.4337184",
      "poi_longitude": "-84.2901536",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 850-386-4404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-aa2c-7628-8d8d-cca63f8b02bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e12-aa2c-7628-8d8d-cca63f8b02bb",
        "storage_key": "property/6737460151191753/019e1e12-aa2c-7628-8d8d-cca63f8b02bb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aTJx2z17IgRq06AvYMpimE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e8ff25a4-d32a-4c11-9bea-63348ecc3563",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "The Moon",
      "poi_type": "Entertainment",
      "poi_address": "1105 E Lafayette St, Tallahassee, FL 32301, USA",
      "poi_short_description": "Nightlife spot with bars & lounge hosting DJs & live music from country to rap, plus special events.",
      "poi_long_description": "Nightlife spot with bars & lounge hosting DJs & live music from country to rap, plus special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-8066-77b2-b480-d62501026c10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-8066-77b2-b480-d62501026c10",
        "storage_key": "property/6737460151191753/019e1e12-8066-77b2-b480-d62501026c10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.moonevents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7401916877064262767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-moon",
      "poi_latitude": "30.4357734",
      "poi_longitude": "-84.2656993",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-878-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZbxvYhf7IgRb1Riwi7kuGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_31809aee-26da-4512-bd1b-6b85d84b165f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Donald L. Tucker Civic Center",
      "poi_type": "Entertainment",
      "poi_address": "505 W Pensacola St, Tallahassee, FL 32301, USA",
      "poi_short_description": "Vast destination for conventions, sports, concerts & seasonal events, such as rodeos & the circus.",
      "poi_long_description": "Vast destination for conventions, sports, concerts & seasonal events, such as rodeos & the circus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-14a4-761e-bb33-fbedb4701cfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0f-14a4-761e-bb33-fbedb4701cfa",
        "storage_key": "property/6737460151191753/019e1e0f-14a4-761e-bb33-fbedb4701cfa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.tuckerciviccenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17792063155482139049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donald-l-tucker-civic-center",
      "poi_latitude": "30.4377823",
      "poi_longitude": "-84.2866581",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-644-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWvmiW317IgRqRnUaywb6vY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_a17fb0cd-9b23-4704-bd2a-993c3bad0bc6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida Historic Capitol Museum",
      "poi_type": "Entertainment",
      "poi_address": "400 S Monroe St, Tallahassee, FL 32399, USA",
      "poi_short_description": "Museum with political artifacts, photos & interactive exhibits in a historic government building.",
      "poi_long_description": "Museum with political artifacts, photos & interactive exhibits in a historic government building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-8434-70e8-be54-21c4482fb714.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-8434-70e8-be54-21c4482fb714",
        "storage_key": "property/6737460151191753/019e1e12-8434-70e8-be54-21c4482fb714.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://flhistoriccapitol.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14601949651190867024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-historic-capitol-museum",
      "poi_latitude": "30.4381359",
      "poi_longitude": "-84.2813118",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-487-1902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5",
        "storage_key": "property/6737460151191753/019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSShInD17IgRUORe49eLpMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_574714a4-b6e5-42ec-b0b7-a512f8c00bb5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Tallahassee Museum",
      "poi_type": "Entertainment",
      "poi_address": "3945 Museum Rd, Tallahassee, FL 32310, USA",
      "poi_short_description": "A 52-acre lakeside site featuring wildife, nature trail, period exhibits, events & zipline tours.",
      "poi_long_description": "A 52-acre lakeside site featuring wildife, nature trail, period exhibits, events & zipline tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-8533-74e5-b813-696f38c20307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-8533-74e5-b813-696f38c20307",
        "storage_key": "property/6737460151191753/019e1e12-8533-74e5-b813-696f38c20307.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tallahasseemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=170495709765873901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tallahassee-museum",
      "poi_latitude": "30.4104779",
      "poi_longitude": "-84.34403950000001",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 850-575-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5",
        "storage_key": "property/6737460151191753/019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT8lyCbL07IgR7bBS2PG4XQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8d1bbd7e-f2d8-404e-84a5-e8b29cc686a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Cap City Video Lounge",
      "poi_type": "Entertainment",
      "poi_address": "636-1 Railroad Sq, Tallahassee, FL 32310, USA",
      "poi_short_description": "Funky video store offering a large selection of movies, including vintage ones, plus snacks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-84bd-715f-b9d7-8d72c0c56231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-84bd-715f-b9d7-8d72c0c56231",
        "storage_key": "property/6737460151191753/019e1e12-84bd-715f-b9d7-8d72c0c56231.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://capcityvideo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9952645609171845023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cap-city-video-lounge",
      "poi_latitude": "30.4329007",
      "poi_longitude": "-84.29234029999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 850-765-0147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCy7ibWP07IgRn_8JPnPmHoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_8d6a925c-4c2f-4977-8db5-2a8181043d37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida State University Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "530 W Call St, Tallahassee, FL 32306, USA",
      "poi_short_description": "FSU-affiliated art museum promoting contemporary & traditional works, as well as student exhibits.",
      "poi_long_description": "FSU-affiliated art museum promoting contemporary & traditional works, as well as student exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-84bb-72c8-9224-58f8926ee98d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-84bb-72c8-9224-58f8926ee98d",
        "storage_key": "property/6737460151191753/019e1e12-84bb-72c8-9224-58f8926ee98d.webp",
        "width": 1131,
        "height": 1280
      },
      "poi_business_url": "http://mofa.fsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14975873285202554563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-state-university-museum-of-fine-arts",
      "poi_latitude": "30.4437927",
      "poi_longitude": "-84.2898305",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 850-644-6836",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5",
        "storage_key": "property/6737460151191753/019e1e0f-3f29-75c8-ba0c-2d2323ae3ed5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRE_o3T17IgRw67CRWj91M8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_14b833f7-d3d6-4d2f-af4d-8754b18fb055",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Tallahassee Memorial Urgent Care Center on Medical Drive",
      "poi_type": "Health and Wellness",
      "poi_address": "1541 Medical Dr, Tallahassee, FL 32308, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-88b9-76c4-ad6a-6b1148821ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-88b9-76c4-ad6a-6b1148821ca9",
        "storage_key": "property/6737460151191753/019e1e12-88b9-76c4-ad6a-6b1148821ca9.webp",
        "width": 752,
        "height": 423
      },
      "poi_business_url": "https://www.tmh.org/location/tallahassee-memorial-urgent-care-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7739611656414654491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tallahassee-memorial-urgent-care-center-on-medical-drive",
      "poi_latitude": "30.4590599",
      "poi_longitude": "-84.2592505",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-431-7816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22D_B3Bf7IgRG3ARmMufaGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_861bacd9-fcf1-41c2-8a02-853257fdc932",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "414 S Magnolia Dr Walgreens, Tallahassee, FL 32301, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-8bc5-7706-bdf2-61dae864f3f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-8bc5-7706-bdf2-61dae864f3f1",
        "storage_key": "property/6737460151191753/019e1e12-8bc5-7706-bdf2-61dae864f3f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-414+s+magnolia+dr-tallahassee-fl-32301/id=11537",
      "poi_directions_map_url": "https://maps.google.com/?cid=14305975840969158549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.4378977",
      "poi_longitude": "-84.262326",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 850-877-3023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFznpnoVf7IgRlW9JJjsJicY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_388ca4ab-d19e-4537-b1b4-d41f8659a538",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3535 Apalachee Pkwy, Tallahassee, FL 32311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-8a53-73c1-a2d9-878b068c7020.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-8a53-73c1-a2d9-878b068c7020",
        "storage_key": "property/6737460151191753/019e1e12-8a53-73c1-a2d9-878b068c7020.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1077-tallahassee-fl/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3546275752109244294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "30.4258815",
      "poi_longitude": "-84.2140072",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-656-4593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-aa39-723b-90a1-ea0b61076b79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e12-aa39-723b-90a1-ea0b61076b79",
        "storage_key": "property/6737460151191753/019e1e12-aa39-723b-90a1-ea0b61076b79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53C9sEZe7IgRhn8N8AHnNjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_509981e6-ae62-4961-adf9-a5bbe6ce497b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2001 Apalachee Pkwy, Tallahassee, FL 32301, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-8b73-724d-817d-dddc4cd4df36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-8b73-724d-817d-dddc4cd4df36",
        "storage_key": "property/6737460151191753/019e1e12-8b73-724d-817d-dddc4cd4df36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12118759152646432742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca",
      "poi_latitude": "30.4298354",
      "poi_longitude": "-84.2472868",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 850-877-6151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkRtO-IZg7IgR5icBzD17Lqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_f507b175-d227-493e-84a7-10b2a0551147",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "BodyTrac Health & Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 E Park Ave Suite 2900, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://bodytrac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8144156730468575598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodytrac-health--fitness",
      "poi_latitude": "30.4414037",
      "poi_longitude": "-84.2292174",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 850-574-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1pDsFRe7IgRbqmvkmXbBXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f5c400ad-309e-4106-b1cf-bd625122da3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "FIT AS FIRE College Town",
      "poi_type": "Health and Wellness",
      "poi_address": "815 W Madison St, Tallahassee, FL 32304, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-9917-746a-bdbf-0f0c3f5e9d4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-9917-746a-bdbf-0f0c3f5e9d4e",
        "storage_key": "property/6737460151191753/019e1e12-9917-746a-bdbf-0f0c3f5e9d4e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fitaf.com/college-town/?utm_source=google&utm_medium=organic&utm_campaign=gbp_collegetown_madison",
      "poi_directions_map_url": "https://maps.google.com/?cid=6610313307083248080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-as-fire-college-town",
      "poi_latitude": "30.4360213",
      "poi_longitude": "-84.2966988",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 850-445-3803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb7I1GbH17IgR0BG8Cu6MvFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_be36a202-8cd3-446a-848d-65f34b781f4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Flowstate Hot HIIT Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "1130 Thomasville Rd, Tallahassee, FL 32303, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-933f-7729-86ee-3fff9a398750.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-933f-7729-86ee-3fff9a398750",
        "storage_key": "property/6737460151191753/019e1e12-933f-7729-86ee-3fff9a398750.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.flowstatemidtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18102728650782618753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flowstate-hot-hiit-studio",
      "poi_latitude": "30.4551998",
      "poi_longitude": "-84.2785971",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 850-250-5883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ-ls7U317IgRgTQvp8vPOfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_64694c2d-4c49-4623-9c90-ef656549018f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Ponce de Leon",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "127 E Park Ave, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-8fba-721d-856b-58025e402eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-8fba-721d-856b-58025e402eb1",
        "storage_key": "property/6737460151191753/019e1e12-8fba-721d-856b-58025e402eb1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18405415698606031842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponce-de-leon",
      "poi_latitude": "30.4420138",
      "poi_longitude": "-84.2812933",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f45-734c-9237-fdd1a7f4b363",
        "storage_key": "property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgziVvHD17IgR4oPP0g8sbf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_21529a3c-bcd3-4be7-a572-35f3ab5c304f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Kleman Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "306 S Duval St, Tallahassee, FL 32301, USA",
      "poi_short_description": "Venue featuring an IMAX theater and a public restroom, plus the Clemens Park site of festivals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-90cd-77fb-820d-d904823d7686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-90cd-77fb-820d-d904823d7686",
        "storage_key": "property/6737460151191753/019e1e12-90cd-77fb-820d-d904823d7686.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18224934818427669326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kleman-plaza",
      "poi_latitude": "30.4397094",
      "poi_longitude": "-84.28359999999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f45-734c-9237-fdd1a7f4b363",
        "storage_key": "property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4QhrnH17IgRTosHU6j56_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f1c9ff10-c1d4-4cf8-9cd3-6b74382a9e2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Railroad Square Art District",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Tallahassee, FL 32310, USA",
      "poi_short_description": "Quaint district with 70+ working artist studios, galleries, shops, and a cafe in a former train caboose.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-907e-762e-b3c3-ccecb9f1d696.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-907e-762e-b3c3-ccecb9f1d696",
        "storage_key": "property/6737460151191753/019e1e12-907e-762e-b3c3-ccecb9f1d696.webp",
        "width": 1153,
        "height": 1280
      },
      "poi_business_url": "http://www.railroadsquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6243918025611911443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "railroad-square-art-district",
      "poi_latitude": "30.433016",
      "poi_longitude": "-84.291037",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 850-224-1308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXJBTBP17IgRE6FB01zaplY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_0a7f0665-c55f-4354-b679-678a66f4fd83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Tom Brown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501 Easterwood Dr, Tallahassee, FL 32311, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-963e-72b4-98f4-d6e48c688706.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-963e-72b4-98f4-d6e48c688706",
        "storage_key": "property/6737460151191753/019e1e12-963e-72b4-98f4-d6e48c688706.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10000852624197023348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-brown-park",
      "poi_latitude": "30.4482398",
      "poi_longitude": "-84.2168016",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2uT04Zf7IgRdPZLlHkqyoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_5eb9fbde-1242-4a74-b5db-83090a65f2b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Lake Ella Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S Lake Ella Dr, Tallahassee, FL 32303, USA",
      "poi_short_description": "Park with a playground, picnic tables, and a gazebo, plus many geese and ducks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-9841-771d-b08e-0ae0a53a2fe8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-9841-771d-b08e-0ae0a53a2fe8",
        "storage_key": "property/6737460151191753/019e1e12-9841-771d-b08e-0ae0a53a2fe8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.talgov.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11585606005362378212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-ella-park",
      "poi_latitude": "30.461047",
      "poi_longitude": "-84.2794009",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 850-891-6860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f45-734c-9237-fdd1a7f4b363",
        "storage_key": "property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG4KiWYX17IgR5MVBWUdXyKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1df698a9-9683-4764-a142-c53b190bb547",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Winthrop Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1601 Mitchell Ave, Tallahassee, FL 32303, USA",
      "poi_short_description": "Park featuring playgrounds, tennis courts and baseball fields, plus a batting cage.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-9a49-743f-b695-b0f9a445b715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-9a49-743f-b695-b0f9a445b715",
        "storage_key": "property/6737460151191753/019e1e12-9a49-743f-b695-b0f9a445b715.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17134943459076064387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winthrop-park",
      "poi_latitude": "30.4641997",
      "poi_longitude": "-84.26746729999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-891-3980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f45-734c-9237-fdd1a7f4b363",
        "storage_key": "property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMebGrGNf7IgRg8ShjEqMy-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d44d783a-8668-4c31-9b2e-b66f621a1447",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Alfred B. Maclay Gardens State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3540 Thomasville Rd, Tallahassee, FL 32309, USA",
      "poi_short_description": "Centered around manicured gardens, this park also features trails, swimming, fishing & kayaking.",
      "poi_long_description": "Centered around manicured gardens, this park also features trails, swimming, fishing & kayaking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-2fa8-7521-a6e2-35d641d33a59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0f-2fa8-7521-a6e2-35d641d33a59",
        "storage_key": "property/6737460151191753/019e1e0f-2fa8-7521-a6e2-35d641d33a59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.floridastateparks.org/park/Maclay-Gardens",
      "poi_directions_map_url": "https://maps.google.com/?cid=6448267300609113895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alfred-b-maclay-gardens-state-park",
      "poi_latitude": "30.51354559999999",
      "poi_longitude": "-84.24748740000001",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 850-487-4556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f45-734c-9237-fdd1a7f4b363",
        "storage_key": "property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcTjNAZVY7IgRJ7-SDfLYfFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_e98761b0-f0be-4110-845f-5cc39984e3a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Lafayette Heritage Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4900 Heritage Park Blvd, Tallahassee, FL 32311, USA",
      "poi_short_description": "Picturesque park known for its multi-use trails, wooden pedestrian bridge, fishing & boating.",
      "poi_long_description": "Picturesque park known for its multi-use trails, wooden pedestrian bridge, fishing & boating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-305c-72de-84c1-fa7f78260184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0f-305c-72de-84c1-fa7f78260184",
        "storage_key": "property/6737460151191753/019e1e0f-305c-72de-84c1-fa7f78260184.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "http://www.talgov.com/parks/parks-trail-lafayette.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13340339293788519070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lafayette-heritage-trail-park",
      "poi_latitude": "30.4397201",
      "poi_longitude": "-84.19209479999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-891-3866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f45-734c-9237-fdd1a7f4b363",
        "storage_key": "property/6737460151191753/019e1e0f-3f45-734c-9237-fdd1a7f4b363.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXU6Lnxe7IgRnjpzVehnIrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bd8f6048-cfb5-4aba-9a04-a84a0ede4b83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "C.K. Steele Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "111 W Tennessee St, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-9cac-705b-9b74-925a6ef28a22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-9cac-705b-9b74-925a6ef28a22",
        "storage_key": "property/6737460151191753/019e1e12-9cac-705b-9b74-925a6ef28a22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.talgov.com/starmetro/CKSteelePlazaGateMap.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1787006381381018894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ck-steele-plaza",
      "poi_latitude": "30.4439944",
      "poi_longitude": "-84.28256309999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-891-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyYGlP2D17IgRDmWS_dW4zBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_fc784c00-ab7f-4f0c-bb78-3e21ff6ad21f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Tallahassee International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3300 Capital Cir SW, Tallahassee, FL 32310, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-9cad-74c0-9d07-126d43da34ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-9cad-74c0-9d07-126d43da34ab",
        "storage_key": "property/6737460151191753/019e1e12-9cad-74c0-9d07-126d43da34ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tlhairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11796955158921999131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tallahassee-international-airport",
      "poi_latitude": "30.3954251",
      "poi_longitude": "-84.3450525",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 850-891-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-aa2a-7549-8ed8-eba307407ecd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e12-aa2a-7549-8ed8-eba307407ecd",
        "storage_key": "property/6737460151191753/019e1e12-aa2a-7549-8ed8-eba307407ecd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-c-4alCL7IgRG_PBzjY0t6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_78c376a1-b4c0-4914-a16a-f941c7cec5dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "StarMetro",
      "poi_type": "Transportation & Transit",
      "poi_address": "555 Appleyard Dr, Tallahassee, FL 32304, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-9fc4-74c9-bbb6-ed4c3de37dc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-9fc4-74c9-bbb6-ed4c3de37dc2",
        "storage_key": "property/6737460151191753/019e1e12-9fc4-74c9-bbb6-ed4c3de37dc2.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.talgov.com/starmetro/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7288726331315882119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starmetro",
      "poi_latitude": "30.4354677",
      "poi_longitude": "-84.3373056",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 850-891-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfw96pP07IgRh4geI_vBJmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_ed6da724-71ee-4ccb-9511-ecf096b2ef34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "E Park Avenue and S Meridian Street",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14742022918211698884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "e-park-avenue-and-s-meridian-street",
      "poi_latitude": "30.4418081",
      "poi_longitude": "-84.27747719999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaQRyXv17IgRxACtzrwvlsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_35c7eb51-0c6a-4dbd-9e90-496d236ec060",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "E Park Avenue and Blair Stone Road",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4818206662801581640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "e-park-avenue-and-blair-stone-road",
      "poi_latitude": "30.4419117",
      "poi_longitude": "-84.2475894",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtXQli6Ff7IgRSGa1jm613UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_f6a1c086-45df-49ec-a009-b3750ebb5ce2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Doak S. Campbell Stadium",
      "poi_type": "Transportation & Transit",
      "poi_address": "403 Stadium Dr, Tallahassee, FL 32304, USA",
      "poi_short_description": "Florida State's 82,000-seat football field named for its longtime Hall of Fame coach.",
      "poi_long_description": "Florida State's 82,000-seat football field named for its longtime Hall of Fame coach.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-18a4-774e-b93f-3fb3cf1ada77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0f-18a4-774e-b93f-3fb3cf1ada77",
        "storage_key": "property/6737460151191753/019e1e0f-18a4-774e-b93f-3fb3cf1ada77.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.seminoles.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9206499478166274016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doak-s-campbell-stadium",
      "poi_latitude": "30.4379997",
      "poi_longitude": "-84.30369619999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f45-734c-9237-fbc6540122e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f45-734c-9237-fbc6540122e7",
        "storage_key": "property/6737460151191753/019e1e0f-3f45-734c-9237-fbc6540122e7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMRJAKhv17IgR4H_rTH8OxH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1fb5a28b-2cd2-4d49-9f3c-a1f3435dd799",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida State University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "222 S Copeland St, Tallahassee, FL 32306, USA",
      "poi_short_description": "Founded in 1851, this research school features varied areas of study & a renowned sports program.",
      "poi_long_description": "Founded in 1851, this research school features varied areas of study & a renowned sports program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-1000-7164-b076-393d639e7d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0f-1000-7164-b076-393d639e7d88",
        "storage_key": "property/6737460151191753/019e1e0f-1000-7164-b076-393d639e7d88.webp",
        "width": 1280,
        "height": 516
      },
      "poi_business_url": "http://www.fsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11248602011301414600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-state-university",
      "poi_latitude": "30.442087",
      "poi_longitude": "-84.2979579",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 850-644-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0x3yeHD17IgRyIZdf-4PG5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f25ab0dc-8cf2-4784-b532-8b4c955ed68e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida A&M University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1601 S Martin Luther King Jr Blvd, Tallahassee, FL 32307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-12d1-7780-ba38-935bfa5d8f7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0f-12d1-7780-ba38-935bfa5d8f7a",
        "storage_key": "property/6737460151191753/019e1e0f-12d1-7780-ba38-935bfa5d8f7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.famu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7813380683640035984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-am-university",
      "poi_latitude": "30.4227211",
      "poi_longitude": "-84.2877093",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 850-599-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f34-7028-8405-6b61d0716c01",
        "storage_key": "property/6737460151191753/019e1e0f-3f34-7028-8405-6b61d0716c01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAQAAAIxf7IgRkFpDr1W0bmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8ba963b6-ee2b-44da-99e5-5242da23ad1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida State Capitol",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 S Monroe St, Tallahassee, FL 32399, USA",
      "poi_short_description": "House & Senate chambers & offices in a circa-1977 skyscraper with an adjacent historical museum.",
      "poi_long_description": "House & Senate chambers & offices in a circa-1977 skyscraper with an adjacent historical museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-a162-76bc-a30e-e1ca2ad600c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-a162-76bc-a30e-e1ca2ad600c3",
        "storage_key": "property/6737460151191753/019e1e12-a162-76bc-a30e-e1ca2ad600c3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://dos.myflorida.com/florida-facts/florida-history/the-capitol/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3172059017055825388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-state-capitol",
      "poi_latitude": "30.4381328",
      "poi_longitude": "-84.2825836",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 850-488-6167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f1f-761a-9e01-ce084dd69935.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f1f-761a-9e01-ce084dd69935",
        "storage_key": "property/6737460151191753/019e1e0f-3f1f-761a-9e01-ce084dd69935.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZpxLnD17IgR7O0vpt5qBSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_efab0b67-a792-47d6-90f4-f6d25c24dd79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Leon County Clerk of Courts and Comptroller",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 S Monroe St #100, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-a157-735d-9a30-7178ac3ce94f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-a157-735d-9a30-7178ac3ce94f",
        "storage_key": "property/6737460151191753/019e1e12-a157-735d-9a30-7178ac3ce94f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cvweb.leonclerk.com/public/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14746378721719585573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leon-county-clerk-of-courts-and-comptroller",
      "poi_latitude": "30.4394198",
      "poi_longitude": "-84.2800936",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 850-606-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f1f-761a-9e01-ce084dd69935.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f1f-761a-9e01-ce084dd69935",
        "storage_key": "property/6737460151191753/019e1e0f-3f1f-761a-9e01-ce084dd69935.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXSrdf3D17IgRJYt5V1Gppcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_e29404db-b69c-46df-a336-b17c56f32ced",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Tallahassee City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 S Adams St, Tallahassee, FL 32301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-32c7-776f-af50-5f95513ec80e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0f-32c7-776f-af50-5f95513ec80e",
        "storage_key": "property/6737460151191753/019e1e0f-32c7-776f-af50-5f95513ec80e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.talgov.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3748746805523347340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tallahassee-city-hall",
      "poi_latitude": "30.4396143",
      "poi_longitude": "-84.2824356",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 850-891-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f1f-761a-9e01-ce084dd69935.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f1f-761a-9e01-ce084dd69935",
        "storage_key": "property/6737460151191753/019e1e0f-3f1f-761a-9e01-ce084dd69935.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4riT3D17IgRjHcZoFs5BjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_469d0563-eaa1-4deb-a4c1-6aac98201ade",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Florida Department of Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4052 Bald Cypress Way, Tallahassee, FL 32399, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-a389-75bc-9ea2-2f196cea419c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-a389-75bc-9ea2-2f196cea419c",
        "storage_key": "property/6737460151191753/019e1e12-a389-75bc-9ea2-2f196cea419c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.floridahealth.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16504556384306254200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-department-of-health",
      "poi_latitude": "30.3896474",
      "poi_longitude": "-84.2299463",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 850-245-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f1f-761a-9e01-ce084dd69935.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f1f-761a-9e01-ce084dd69935",
        "storage_key": "property/6737460151191753/019e1e0f-3f1f-761a-9e01-ce084dd69935.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdl2Ln1g7IgReNH6LZb2C-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_ca6d1f05-f37d-4101-b6ca-db039ec1c095",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "poi_name": "Department of Children and Families",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1317 Winewood Blvd #202, Tallahassee, FL 32399, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e12-a21c-7028-87b5-3d59885a5c6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e12-a21c-7028-87b5-3d59885a5c6a",
        "storage_key": "property/6737460151191753/019e1e12-a21c-7028-87b5-3d59885a5c6a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.myflorida.com/accessflorida/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9254419086927968898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "department-of-children-and-families",
      "poi_latitude": "30.4229785",
      "poi_longitude": "-84.2504404",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 850-487-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0f-3f0b-738b-860e-95866ae90edc",
        "storage_key": "property/6737460151191753/019e1e0f-3f0b-738b-860e-95866ae90edc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz6BAapVf7IgRgrrvpiBNboA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d34fb957-5969-4cb0-8b78-78f00d11956c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4a96d661-1148-41c4-8327-d8eed54f2b33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_92386440-3e79-46c3-a8a6-c0baafce25d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8730fde2-35a8-4d32-a5aa-b7b2399d8c57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_14f4d610-9571-4f3f-8af0-352b75b543df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1f6354d0-3763-4b17-a28e-7e8d56cf3e7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1193a2e9-2c6f-4fa4-b5e8-01dc05cb6a87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "rating": "5",
      "name": "Kali Turenne",
      "text": "Kelmarri was very attentive and helpful as a tour guide. He had great energy and enthusiasm for all our questions and concerns!!",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_74cf9527-af65-4871-8673-aa82588dca54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "rating": "5",
      "name": "Kay Renaye",
      "text": "Zarina was very kind and bubbly. The apartments are amazing and definitely give the luxurious vibe for a great cost.",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_1be470fc-ed80-4742-b217-d9a51f2bffec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "rating": "5",
      "name": "Oneman Army",
      "text": "I have a great experience at 2626 Park. Maintenance is quick and gets the job done right, and the office staff is always helpful and respectful. Overall, it’s a well-managed place with solid service.",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_cca01b7a-e5a2-4759-87d2-c2e973c906e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "rating": "5",
      "name": "Cheryl Fulton",
      "text": "Went by to get some information on the apartments. Walked in and was immediately greeted by a smiling young lady by the name of Caitlyn asking how she could help. She answered my questions in a knowledgeable and professional manner. While looking around, the front office was clean and welcoming. The pool and fitness center were also well maintained. The complex location is in a great part of town. Would definitely recommend coming in and talking to the wonderful staff and maybe finding your next place to call home.",
      "date": "2026-04-10",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d2c5b529-52c5-4b65-930a-fe0272cb4656",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019e1dd9-6669-74eb-81f6-86795998930b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd9-6669-74eb-81f6-86795998930b",
        "storage_key": "property/6737460151191753/019e1dd9-6669-74eb-81f6-86795998930b.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=66e9ed87cfe8861991c8117d"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019910d4-4b48-713d-9c7b-4ec359a9a63c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "2626 Park property website",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753"
    },
    {
      "lead_collector_id": "019910d4-4bc3-773c-b684-eda8d3907441",
      "lead_source": "FACEBOOK_ADS",
      "name": "2626 Park facebook ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753"
    },
    {
      "lead_collector_id": "019910d4-4c32-72eb-a1b0-c440b1a68693",
      "lead_source": "LANDING_PAGE",
      "name": "2626 Park landing page",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-tallahassee",
      "search_query": "apartments with in-unit laundry Tallahassee FL",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Tallahassee",
      "h2_subtitle": "Discover 2626 Park's luxurious apartments with in-unit laundry in beautiful Tallahassee, FL. Convenient living with amenities at your fingertips.",
      "page_copy": "At 2626 Park, we offer ideal apartments with in-unit laundry in Tallahassee, FL, designed to enhance your living experience. Our spacious one, two, and three-bedroom floor plans are equipped with modern conveniences, including a washer and dryer in every unit, ensuring comfort and practicality. Relax and unwind in our community with features like a refreshing pool, a state-of-the-art fitness center, and a business center tailored for your lifestyle.\n\nLocated in the charming Governors Square neighborhood, our community provides a perfect blend of convenience and luxury. Experience seamless living with high-speed internet access, ice makers, and even a pet washing station for furry friends. With concierge service and controlled access, you have all the support you need at 2626 Park. Come and see for yourself why our apartments with in-unit laundry in Tallahassee are the ideal choice for your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
        "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Tallahassee, FL",
      "seo_description": "Explore apartments with in-unit laundry at 2626 Park, Tallahassee, FL. Enjoy modern amenities in a prime location!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "generator",
      "page_item_url": "dog-park-apartments-leon-county",
      "search_query": "dog park apartments in Leon County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Leon County",
      "h2_subtitle": "Find pet-friendly apartments with a dog park at 2626 Park in Leon County. Enjoy living where pets are welcome and amenities abound.",
      "page_copy": "Welcome to 2626 Park, the perfect choice for those seeking dog park apartments in Leon County. Our pet-friendly community offers more than just a place to live; it provides a welcoming environment for your furry friends. Here, you'll find spacious one, two, and three-bedroom apartments equipped with modern amenities like in-unit laundry and high-speed internet access.\n\nSet in the vibrant community near Governors Square, 2626 Park ensures both you and your pets feel right at home. Enjoy leisurely days at our pet washing station and take advantage of other top-notch facilities such as our inviting pool and advanced fitness center. With our on-site concierge service and controlled access, both you and your pets will enjoy a secure and comfortable lifestyle in Leon County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
        "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Leon County, FL",
      "seo_description": "Discover dog park apartments at 2626 Park in Leon County. Pet-friendly living with modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "generator",
      "page_item_url": "tallahassee-apartments-swimming-pool",
      "search_query": "Tallahassee apartments with swimming pool",
      "category": "Amenity",
      "h1_title": "Tallahassee Apartments with Swimming Pool",
      "h2_subtitle": "Dive into luxury at 2626 Park, offering Tallahassee apartments with a stunning swimming pool. Enjoy relaxing by the pool in a vibrant community.",
      "page_copy": "Experience premier living at 2626 Park, where Tallahassee apartments with a swimming pool create the perfect blend of comfort and leisure. Our community boasts a sparkling pool, providing a refreshing escape right at your doorstep. Choose from our spacious one, two, and three-bedroom apartments, each featuring stylish interiors and modern amenities like carpeted floors and in-unit laundry.\n\nNestled in the lively Governors Square area, our apartments offer more than just a place to swim. With a fully-equipped fitness center, business center, and high-speed internet access, you'll find everything you need for a well-rounded lifestyle. Our community is pet-friendly, complete with a pet washing station, and ensures peace of mind with concierge services and controlled access. Discover the joys of apartment living with a swimming pool at 2626 Park, Tallahassee.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
        "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tallahassee Apartments with Swimming Pool",
      "seo_description": "Explore 2626 Park for Tallahassee apartments with a swimming pool and top amenities. Schedule your tour today and discover the perfect home!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-governors-square",
      "search_query": "apartments with air conditioning Governors Square",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments at Governors Square",
      "h2_subtitle": "Stay cool in the Governors Square neighborhood with air-conditioned apartments at 2626 Park. Enjoy modern comfort and convenience year-round.",
      "page_copy": "Step into comfort and style with air-conditioned apartments at 2626 Park, located in the desirable Governors Square neighborhood. Our one, two, and three-bedroom floor plans are thoughtfully designed to provide a comfortable living environment, complete with air conditioning to keep you cool throughout the year. Each apartment comes with essential features like in-unit laundry and high-speed internet access, ensuring a seamless living experience.\n\n2626 Park offers more than just a cool retreat; it provides a lifestyle enriched with amenities. Take advantage of facilities such as our modern fitness center, business lounge, and pet-friendly options like a pet washing station. Our community also features a refreshing pool and offers concierge services, adding a touch of luxury to your daily life. Experience air-conditioned comfort and top amenities in the heart of Governors Square.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
        "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments at Governors Square",
      "seo_description": "Discover air-conditioned apartments at 2626 Park, Governors Square. Enjoy modern amenities and cool comfort in a prime Tallahassee location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-32301",
      "search_query": "apartments with fitness center 32301",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in 32301",
      "h2_subtitle": "Discover apartments with a modern fitness center at 2626 Park, located in the 32301 area. Enjoy convenient workouts in a fully-equipped gym.",
      "page_copy": "Welcome to 2626 Park, where you'll find premier apartments with a fitness center in Tallahassee's 32301 zip code. Our community offers a robust lifestyle with a fully-equipped gym, perfect for all your fitness needs. Choose from spacious one, two, and three-bedroom floor plans that provide modern living with amenities like in-unit laundry and high-speed internet access.\n\nConveniently located near Governors Square, 2626 Park combines fitness and comfort within reach. Take advantage of our other exceptional features, including a sparkling swimming pool and pet washing station. Our pet-friendly environment, concierge services, and controlled access ensure a pleasant and secure living experience. Experience a fulfilling lifestyle where your health and wellness are prioritized at 2626 Park, your top choice in the 32301 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
        "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in 32301",
      "seo_description": "Find apartments with a fitness center at 2626 Park, 32301. Enjoy workouts with modern amenities in a prime Tallahassee location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-tallahassee-fl",
      "search_query": "one bedroom apartments tallahassee fl",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Tallahassee, FL",
      "h2_subtitle": "Explore cozy one bedroom apartments at 2626 Park in Tallahassee, FL. Discover a blend of comfort and convenience in our community.",
      "page_copy": "Discover the perfect one bedroom apartments in Tallahassee, FL at 2626 Park. Our thoughtfully designed units provide a cozy and efficient living space that's perfect for individuals or couples. With modern amenities such as carpeted flooring and air conditioning, each one bedroom apartment offers comfort and style. \n\nLocated in the vibrant Governors Square neighborhood, 2626 Park is more than just a place to live—it's a community. Residents enjoy access to high-speed internet, in-unit washer/dryer, and a pet washing station. Our amenities include a fitness center and a stunning pool, perfect for relaxation and recreation. With our concierge services and controlled access, you can truly indulge in a comfortable, convenient lifestyle. Make 2626 Park your home today and enjoy the best of Tallahassee living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
        "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Tallahassee, FL",
      "seo_description": "Discover cozy one bedroom apartments at 2626 Park, Tallahassee, FL. Enjoy comfort and convenience in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-governors-square",
      "search_query": "two bedroom apartments governors square",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments at Governors Square",
      "h2_subtitle": "Find spacious two bedroom apartments at 2626 Park, nestled in the Governors Square area, offering modern amenities and comfortable living.",
      "page_copy": "Experience the comfort of two bedroom apartments at 2626 Park, located in the sought-after Governors Square neighborhood. Our spacious floor plans are perfect for those seeking extra space and flexibility. Each apartment is designed with modern convenience in mind, featuring amenities such as in-unit washer/dryer, high-speed internet access, and premium carpeting.\n\n2626 Park isn't just about living space—it's about lifestyle. Within our community, residents can enjoy a state-of-the-art fitness center, a refreshing swimming pool, and pet-friendly perks like a dedicated pet washing station. With concierge services and controlled access, you can enjoy both luxury and security. Explore the best of what Tallahassee has to offer right outside your door when you make 2626 Park your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
        "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments at Governors Square",
      "seo_description": "Explore two bedroom apartments at 2626 Park in Governors Square. Enjoy spacious living with modern amenities in Tallahassee, FL.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191753",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-leon-county-fl",
      "search_query": "three bedroom apartments leon county fl",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Leon County, FL",
      "h2_subtitle": "Discover spacious living in our three bedroom apartments at 2626 Park, nestled in Leon County, FL. Perfect for families or roomies seeking comfort.",
      "page_copy": "Welcome to spacious living in our three bedroom apartments at 2626 Park, situated in the heart of Leon County, FL. Ideal for families or roommates, our generously sized floor plans offer ample living space that combines comfort and modernity. Each apartment is equipped with essential amenities, including high-speed internet and an in-unit washer/dryer, ensuring a seamless living experience.\n\nLocated conveniently near Governors Square, residents at 2626 Park can enjoy a vibrant lifestyle with community features such as a fitness center, swimming pool, and a pet washing station. Our pet-friendly environment and concierge services are designed to enhance your living. Choose 2626 Park for your three bedroom needs and enjoy all the perks of living in one of Leon County's most desirable communities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019d076d-4220-73fe-b81d-c6b9a007838e",
        "storage_key": "property/6737460151191753/019d076d-4220-73fe-b81d-c6b9a007838e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Leon County, FL",
      "seo_description": "Explore three bedroom apartments at 2626 Park in Leon County, FL. Enjoy spacious living with modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3888"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5025330714"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973408"
    },
    {
      "ID": "custom_best_of_logo",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N65RDBXD"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_db_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=db"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "850-660-9204"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_db_title",
      "type": "STRING",
      "value": "Drive-by"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "850-719-5038"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "850-660-9252"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "850-660-9358"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "850-801-2962"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "850-660-9339"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "850-660-9298"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "850-660-9003"
    },
    {
      "ID": "custom_knock_db_number",
      "type": "STRING",
      "value": "850-695-8898"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "850-750-9140"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "850-660-9351"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "850-818-3152"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "850-998-3874"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "850-660-9280"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "850-407-2575"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "850-750-5514"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "850-805-8027"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "850-801-2843"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "850-660-9147"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "850-787-0490"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321248693"
    },
    {
      "ID": "custom_knock_aptlist_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=aptlist"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "850-660-9258"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "850-809-1497"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "511ee2681b7a81ac"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "850-990-5763"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_aptlist_title",
      "type": "STRING",
      "value": "ApartmentList.com"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "850-660-9040"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "850-660-9321"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_aptlist_number",
      "type": "STRING",
      "value": "850-930-1897"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "850-752-5580"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "850-660-9340"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "850-660-9164"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "850-660-9254"
    },
    {
      "ID": "custom_knock_collegepads_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=collegepads"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.live2626park.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_collegepads_title",
      "type": "STRING",
      "value": "College Pads"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191753/019e60cb-0739-77a8-949a-9dbea7ccc06c.mp4"
    },
    {
      "ID": "custom_knock_collegepads_number",
      "type": "STRING",
      "value": "850-470-1535"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "850-660-9309"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "850-818-3152"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3888",
  "custom_repli_id": "5025330714",
  "custom_realpage_id": "4973408",
  "custom_best_of_logo": "true",
  "custom_knock_a_link": "https://www.live2626park.com?utm_knock=a",
  "custom_knock_g_link": "https://www.live2626park.com?utm_knock=g",
  "custom_knock_r_link": "https://www.live2626park.com?utm_knock=r",
  "custom_knock_w_link": "https://www.live2626park.com?utm_knock=w",
  "custom_knock_z_link": "https://www.live2626park.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-N65RDBXD",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.live2626park.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.live2626park.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.live2626park.com?utm_knock=cl",
  "custom_knock_db_link": "https://www.live2626park.com?utm_knock=db",
  "custom_knock_fb_link": "https://www.live2626park.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.live2626park.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.live2626park.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "850-660-9204",
  "custom_knock_ads_link": "https://www.live2626park.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.live2626park.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_db_title": "Drive-by",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "850-719-5038",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.live2626park.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.live2626park.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.live2626park.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.live2626park.com?utm_knock=psa",
  "custom_knock_r_number": "850-660-9252",
  "custom_knock_w_number": "850-660-9358",
  "custom_knock_z_number": "850-801-2962",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "850-660-9339",
  "custom_knock_amap_link": "https://www.live2626park.com?utm_knock=amap",
  "custom_knock_ar_number": "850-660-9298",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "850-660-9003",
  "custom_knock_db_number": "850-695-8898",
  "custom_knock_fb_number": "850-750-9140",
  "custom_knock_fl_number": "850-660-9351",
  "custom_knock_gp_number": "850-818-3152",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.live2626park.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "850-998-3874",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.live2626park.com?utm_knock=bcard",
  "custom_knock_bnr_number": "850-660-9280",
  "custom_knock_cfres_link": "https://www.live2626park.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "850-407-2575",
  "custom_knock_lgp_number": "850-750-5514",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.live2626park.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "850-805-8027",
  "custom_knock_psa_number": "850-801-2843",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "850-660-9147",
  "custom_knock_bandit_link": "https://www.live2626park.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.live2626park.com?utm_knock=flyers",
  "custom_knock_osoc_number": "850-787-0490",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321248693",
  "custom_knock_aptlist_link": "https://www.live2626park.com?utm_knock=aptlist",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "850-660-9258",
  "custom_knock_cfres_number": "850-809-1497",
  "custom_knock_chatgpt_link": "https://www.live2626park.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "511ee2681b7a81ac",
  "custom_knock_dirmail_link": "https://www.live2626park.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "850-990-5763",
  "custom_knock_propbro_link": "https://www.live2626park.com?utm_knock=propbro",
  "custom_knock_aptlist_title": "ApartmentList.com",
  "custom_knock_bandit_number": "850-660-9040",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "850-660-9321",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.live2626park.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_aptlist_number": "850-930-1897",
  "custom_knock_chatgpt_number": "850-752-5580",
  "custom_knock_dirmail_number": "850-660-9340",
  "custom_knock_propbro_number": "850-660-9164",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "850-660-9254",
  "custom_knock_collegepads_link": "https://www.live2626park.com?utm_knock=collegepads",
  "custom_knock_maintenance_link": "https://www.live2626park.com?utm_knock=maintenance",
  "custom_knock_collegepads_title": "College Pads",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191753/019e60cb-0739-77a8-949a-9dbea7ccc06c.mp4",
  "custom_knock_collegepads_number": "850-470-1535",
  "custom_knock_maintenance_number": "850-660-9309",
  "custom_ppc_tracking_phone_number": "850-818-3152"
};

export const generatedAt = '2026-10-07T17:14:44.874Z';
